var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNofiles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 477.181,
    height: 387.538,
    viewBox: "0 0 477.181 387.538",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5641",
    "data-name": "Group 5641",
    transform: "translate(-100.545 -43.251)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5494",
    "data-name": "Group 5494",
    transform: "translate(169.99 240.584)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9974",
    "data-name": "Path 9974",
    d: "M266.359,402.377l.006,30.5-18.131,10.468-5.471-3.159.115,6.171L224.747,456.83l-14.5-8.449.442,17.509-18.131,10.468h23.791l88.4-51.815Z",
    transform: "translate(-192.562 -328.677)",
    fill: "#f8f7fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9975",
    "data-name": "Path 9975",
    d: "M410.505,432.466l-29.979-.053,10.592-6.543Z",
    transform: "translate(-238.669 -334.44)",
    fill: "#f8f7fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9976",
    "data-name": "Path 9976",
    d: "M441.372,434.5h22.633l81.61-47.118-16.3-9.468.008,5.809Z",
    transform: "translate(-253.594 -322.676)",
    fill: "#f8f7fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9977",
    "data-name": "Path 9977",
    d: "M586.364,372.365l78.312-45.214V304.722l30.31,17.955-85.981,49.687Z",
    transform: "translate(-289.161 -304.722)",
    fill: "#f8f7fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9978",
    "data-name": "Path 9978",
    d: "M434.793,479.94v21.944l-62.4,36.024h22.641l69.943-40.382Z",
    transform: "translate(-236.675 -347.703)",
    fill: "#f8f7fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9979",
    "data-name": "Path 9979",
    d: "M664.424,439.353l0,22.61-78.312,45.214h25.66l85.062-49.11Z",
    transform: "translate(-289.099 -337.747)",
    fill: "#f8f7fa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5640",
    "data-name": "Group 5640",
    transform: "translate(100.545 43.251)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5507",
    "data-name": "Group 5507",
    transform: "translate(80.304 86.303)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5506",
    "data-name": "Group 5506",
    transform: "translate(1.513 5.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9980",
    "data-name": "Path 9980",
    d: "M271.351,322.664l78.31-45.212-62.4-36.024-78.31,45.212Z",
    transform: "translate(-208.955 -183.459)",
    fill: "#636094"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9981",
    "data-name": "Path 9981",
    d: "M312.717,164.618v57.968l62.4,36.024V200.643Z",
    transform: "translate(-234.408 -164.618)",
    fill: "#b7bbd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9982",
    "data-name": "Path 9982",
    d: "M287.265,222.586,221.544,260.53l-12.589-50.7,78.31-45.212Z",
    transform: "translate(-208.955 -164.618)",
    fill: "#e6edf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9983",
    "data-name": "Path 9983",
    d: "M208.955,209.831l62.4,36.024,78.31-45.212-62.4-36.025Zm62.4,34.033L212.4,209.831l74.86-43.221,58.947,34.033Z",
    transform: "translate(-208.955 -164.618)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5498",
    "data-name": "Group 5498",
    transform: "translate(12.589 7.376)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5495",
    "data-name": "Group 5495"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9984",
    "data-name": "Path 9984",
    d: "M225.636,246.435l58.813-33.956V176.56c0-1.937-1.36-2.722-3.038-1.754l-10.7,6.179a6.342,6.342,0,0,0-2.286,2.518l-2.534,4.806a6.342,6.342,0,0,1-2.286,2.518l-34.931,20.167a6.713,6.713,0,0,0-3.037,5.261Z",
    transform: "translate(-225.636 -174.391)",
    fill: "#ffb236"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9985",
    "data-name": "Path 9985",
    d: "M226.9,247.7l58.813-33.956v-35.92c0-1.937-1.36-2.722-3.038-1.754l-10.7,6.18a6.345,6.345,0,0,0-2.286,2.517l-2.534,4.807a6.345,6.345,0,0,1-2.286,2.517L229.94,212.261a6.714,6.714,0,0,0-3.037,5.26Z",
    transform: "translate(-225.947 -174.702)",
    fill: "#ffdd57"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5496",
    "data-name": "Group 5496",
    transform: "translate(4.079 11.057)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9986",
    "data-name": "Path 9986",
    d: "M283.4,224.067,231.04,254.295V219.271L283.4,189.043Z",
    transform: "translate(-231.04 -189.043)",
    fill: "#dce7f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9987",
    "data-name": "Path 9987",
    d: "M285.931,226.6,233.575,256.83V221.805l52.356-30.228Z",
    transform: "translate(-231.662 -189.665)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9988",
    "data-name": "Path 9988",
    d: "M285.309,190.956l-1.913-1.913L231.04,219.271l1.913,1.913Z",
    transform: "translate(-231.04 -189.043)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5497",
    "data-name": "Group 5497",
    transform: "translate(7.652 13.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9989",
    "data-name": "Path 9989",
    d: "M294.588,224.484,235.775,258.44V222.52a6.713,6.713,0,0,1,3.037-5.26l18.157-10.484a2.058,2.058,0,0,1,2.286-.122l2.534,1.881a2.056,2.056,0,0,0,2.286-.122l27.476-15.864c1.678-.968,3.038-.183,3.038,1.754Z",
    transform: "translate(-235.775 -192.134)",
    fill: "#ffb236"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9990",
    "data-name": "Path 9990",
    d: "M295.855,245.871l-58.813,33.956v-56.04a6.713,6.713,0,0,1,3.038-5.26l18.157-10.484a2.057,2.057,0,0,1,2.286-.122l2.534,1.881a2.058,2.058,0,0,0,2.286-.122l27.476-15.863c1.677-.969,3.037-.183,3.037,1.753Z",
    transform: "translate(-236.086 -192.445)",
    fill: "#ff7f8e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5502",
    "data-name": "Group 5502",
    transform: "translate(35.967 15.712)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5499",
    "data-name": "Group 5499"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9991",
    "data-name": "Path 9991",
    d: "M256.612,269.553,315.425,235.6V187.605c0-1.937-1.36-2.721-3.038-1.753l-10.7,6.179a6.342,6.342,0,0,0-2.286,2.518l-2.534,4.806a6.347,6.347,0,0,1-2.286,2.518l-34.931,20.167a6.714,6.714,0,0,0-3.037,5.261Z",
    transform: "translate(-256.612 -185.437)",
    fill: "#ffb236"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9992",
    "data-name": "Path 9992",
    d: "M257.879,270.82l58.813-33.956V188.873c0-1.937-1.36-2.722-3.037-1.754l-10.7,6.179a6.353,6.353,0,0,0-2.286,2.518l-2.534,4.806a6.346,6.346,0,0,1-2.285,2.518l-34.931,20.167a6.715,6.715,0,0,0-3.038,5.261Z",
    transform: "translate(-256.923 -185.748)",
    fill: "#ffdd57"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5500",
    "data-name": "Group 5500",
    transform: "translate(3.228 10.294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9993",
    "data-name": "Path 9993",
    d: "M313.246,246.174,260.89,276.4V229.3l52.356-30.228Z",
    transform: "translate(-260.89 -199.077)",
    fill: "#dce7f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9994",
    "data-name": "Path 9994",
    d: "M315.78,236.636l-52.356,30.228V231.84l52.356-30.228Z",
    transform: "translate(-261.512 -199.699)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9995",
    "data-name": "Path 9995",
    d: "M315.159,200.99l-1.913-1.913L260.89,229.3l1.913,1.913Z",
    transform: "translate(-260.89 -199.077)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5501",
    "data-name": "Group 5501",
    transform: "translate(7.652 13.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9996",
    "data-name": "Path 9996",
    d: "M325.564,235.53l-58.813,33.956V233.566a6.714,6.714,0,0,1,3.037-5.261l18.157-10.483a2.058,2.058,0,0,1,2.286-.122l2.534,1.881a2.058,2.058,0,0,0,2.286-.122L322.526,203.6c1.678-.968,3.038-.183,3.038,1.753Z",
    transform: "translate(-266.751 -203.18)",
    fill: "#ff5d73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9997",
    "data-name": "Path 9997",
    d: "M326.831,236.8l-58.813,33.956v-35.92a6.713,6.713,0,0,1,3.038-5.26l18.157-10.484a2.058,2.058,0,0,1,2.286-.122l2.534,1.881a2.058,2.058,0,0,0,2.286-.122l27.476-15.864c1.677-.968,3.037-.183,3.037,1.754Z",
    transform: "translate(-267.062 -203.491)",
    fill: "#ff7f8e"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_9998",
    "data-name": "Path 9998",
    d: "M291.631,315.531l78.312-45.214V212.35l-78.312,45.214Z",
    transform: "translate(-229.235 -176.327)",
    fill: "#7076a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9999",
    "data-name": "Path 9999",
    d: "M369.943,212.35h-3.451l-74.861,43.221v1.991Z",
    transform: "translate(-229.235 -176.327)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10000",
    "data-name": "Path 10000",
    d: "M271.351,260.55v-1.991L212.4,224.526h-3.449Z",
    transform: "translate(-208.955 -179.313)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10001",
    "data-name": "Path 10001",
    d: "M239.535,257.7a2.528,2.528,0,0,0-.329,1.352v5.546a5.3,5.3,0,0,0,2.213,4.228l14.044,8.108a1.875,1.875,0,0,0,.734.254,1.283,1.283,0,0,1-1.884.321L240.27,269.4a5.3,5.3,0,0,1-2.214-4.228v-5.546C238.056,258.337,238.674,257.6,239.535,257.7Z",
    transform: "translate(-216.093 -187.448)",
    fill: "#cdd4ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10002",
    "data-name": "Path 10002",
    d: "M208.955,224.526v57.968l62.4,36.024V260.55Zm21.963,26.962c0-1.629.991-2.378,2.214-1.673l14.043,8.109a5.3,5.3,0,0,1,2.213,4.229V267.7c0,1.629-.99,2.379-2.213,1.673l-14.043-8.109a5.3,5.3,0,0,1-2.214-4.228Z",
    transform: "translate(-208.955 -179.313)",
    fill: "#7076a5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5505",
    "data-name": "Group 5505",
    transform: "translate(18.291 83.943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10003",
    "data-name": "Path 10003",
    d: "M233.19,292.887l24.555,14.177V290.022L233.19,275.845Z",
    transform: "translate(-233.19 -275.845)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5503",
    "data-name": "Group 5503",
    transform: "translate(3.068 5.601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10004",
    "data-name": "Path 10004",
    d: "M237.255,283.93l18.42,10.635V293.9l-18.42-10.635Z",
    transform: "translate(-237.255 -283.267)",
    fill: "#8187b2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5504",
    "data-name": "Group 5504",
    transform: "translate(3.068 10.296)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10005",
    "data-name": "Path 10005",
    d: "M237.255,290.151l18.42,10.635v-.664l-18.42-10.635Z",
    transform: "translate(-237.255 -289.487)",
    fill: "#8187b2"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10006",
    "data-name": "Path 10006",
    d: "M328.227,277.348v19.5l31.016-17.907v-19.5Z",
    transform: "translate(-238.212 -187.878)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10007",
    "data-name": "Path 10007",
    d: "M336,291.352v.918l19.291-11.138v-.918Z",
    transform: "translate(-240.118 -192.973)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10008",
    "data-name": "Path 10008",
    d: "M336,284.2v.918l19.291-11.138v-.918Z",
    transform: "translate(-240.118 -191.219)",
    fill: "#8187b2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10009",
    "data-name": "Path 10009",
    d: "M206.949,203.688,286.769,157.6l63.9,36.9-79.819,46.083Z",
    transform: "translate(-206.949 -157.605)",
    fill: "#cdd4ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10010",
    "data-name": "Path 10010",
    d: "M206.949,218.667v7.547l63.9,36.9v-7.547Z",
    transform: "translate(-206.949 -172.583)",
    fill: "#b7bbd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10011",
    "data-name": "Path 10011",
    d: "M291.625,252.576v7.547l79.819-46.083v-7.547Z",
    transform: "translate(-227.72 -169.597)",
    fill: "#cdd4ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5520",
    "data-name": "Group 5520",
    transform: "translate(302.739 120.477)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5519",
    "data-name": "Group 5519",
    transform: "translate(1.513 5.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10012",
    "data-name": "Path 10012",
    d: "M566.084,367.946l78.31-45.212L582,286.71l-78.31,45.212Z",
    transform: "translate(-503.688 -228.741)",
    fill: "#636094"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10013",
    "data-name": "Path 10013",
    d: "M607.45,209.9v57.968l62.4,36.024V245.925Z",
    transform: "translate(-529.14 -209.9)",
    fill: "#b7bbd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10014",
    "data-name": "Path 10014",
    d: "M582,267.868l-65.721,37.944-12.589-50.7L582,209.9Z",
    transform: "translate(-503.688 -209.9)",
    fill: "#e6edf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10015",
    "data-name": "Path 10015",
    d: "M503.688,255.113l62.4,36.024,78.31-45.213L582,209.9Zm62.4,34.033-58.947-34.033L582,211.892l58.947,34.033Z",
    transform: "translate(-503.688 -209.9)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5511",
    "data-name": "Group 5511",
    transform: "translate(12.589 7.376)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5508",
    "data-name": "Group 5508"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10016",
    "data-name": "Path 10016",
    d: "M520.368,291.717l58.813-33.956V221.842c0-1.937-1.359-2.722-3.037-1.754l-10.7,6.179a6.346,6.346,0,0,0-2.285,2.518l-2.534,4.806a6.352,6.352,0,0,1-2.286,2.518l-34.931,20.167a6.715,6.715,0,0,0-3.038,5.261Z",
    transform: "translate(-520.368 -219.673)",
    fill: "#ffb236"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10017",
    "data-name": "Path 10017",
    d: "M521.636,292.985l58.813-33.956V223.109c0-1.937-1.36-2.722-3.038-1.754l-10.7,6.179a6.344,6.344,0,0,0-2.286,2.517l-2.534,4.807a6.344,6.344,0,0,1-2.286,2.517l-34.931,20.168a6.714,6.714,0,0,0-3.037,5.26Z",
    transform: "translate(-520.679 -219.984)",
    fill: "#ffdd57"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5509",
    "data-name": "Group 5509",
    transform: "translate(4.079 11.057)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10018",
    "data-name": "Path 10018",
    d: "M578.129,269.349l-52.356,30.228V264.553l52.356-30.228Z",
    transform: "translate(-525.773 -234.325)",
    fill: "#dce7f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10019",
    "data-name": "Path 10019",
    d: "M580.664,271.884l-52.356,30.228V267.087l52.356-30.228Z",
    transform: "translate(-526.395 -234.947)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10020",
    "data-name": "Path 10020",
    d: "M580.042,236.238l-1.913-1.913-52.356,30.228,1.913,1.913Z",
    transform: "translate(-525.773 -234.325)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5510",
    "data-name": "Group 5510",
    transform: "translate(7.653 13.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10021",
    "data-name": "Path 10021",
    d: "M589.321,269.766l-58.813,33.956V267.8a6.714,6.714,0,0,1,3.037-5.261L551.7,252.058a2.058,2.058,0,0,1,2.286-.122l2.534,1.881a2.055,2.055,0,0,0,2.285-.122l27.476-15.864c1.678-.968,3.038-.183,3.038,1.754Z",
    transform: "translate(-530.508 -237.416)",
    fill: "#ffb236"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10022",
    "data-name": "Path 10022",
    d: "M590.588,291.153l-58.813,33.956v-56.04a6.714,6.714,0,0,1,3.037-5.26l18.157-10.484a2.056,2.056,0,0,1,2.286-.122l2.534,1.881a2.058,2.058,0,0,0,2.286-.122L587.55,239.1c1.678-.969,3.038-.183,3.038,1.753Z",
    transform: "translate(-530.819 -237.727)",
    fill: "#ffdd57"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5515",
    "data-name": "Group 5515",
    transform: "translate(35.967 15.712)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5512",
    "data-name": "Group 5512"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10023",
    "data-name": "Path 10023",
    d: "M551.345,314.835l58.813-33.956V232.887c0-1.937-1.36-2.722-3.038-1.753l-10.7,6.179a6.342,6.342,0,0,0-2.286,2.518l-2.534,4.806a6.347,6.347,0,0,1-2.286,2.518l-34.931,20.167a6.712,6.712,0,0,0-3.037,5.261Z",
    transform: "translate(-551.345 -230.719)",
    fill: "#ff5d73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10024",
    "data-name": "Path 10024",
    d: "M552.612,316.1l58.813-33.956V234.155c0-1.937-1.36-2.722-3.038-1.754l-10.7,6.179A6.341,6.341,0,0,0,595.4,241.1l-2.534,4.806a6.342,6.342,0,0,1-2.286,2.518l-34.931,20.167a6.717,6.717,0,0,0-3.037,5.261Z",
    transform: "translate(-551.656 -231.03)",
    fill: "#ff7f8e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5513",
    "data-name": "Group 5513",
    transform: "translate(3.228 10.294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10025",
    "data-name": "Path 10025",
    d: "M607.979,291.455l-52.356,30.228v-47.1l52.356-30.228Z",
    transform: "translate(-555.623 -244.359)",
    fill: "#dce7f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10026",
    "data-name": "Path 10026",
    d: "M610.513,281.918l-52.356,30.228V277.122l52.356-30.228Z",
    transform: "translate(-556.244 -244.981)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10027",
    "data-name": "Path 10027",
    d: "M609.892,246.272l-1.913-1.913-52.356,30.228,1.913,1.913Z",
    transform: "translate(-555.623 -244.359)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5514",
    "data-name": "Group 5514",
    transform: "translate(7.652 13.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10028",
    "data-name": "Path 10028",
    d: "M620.3,280.812l-58.813,33.956V278.848a6.714,6.714,0,0,1,3.037-5.261L582.678,263.1a2.058,2.058,0,0,1,2.286-.122l2.534,1.881a2.058,2.058,0,0,0,2.286-.122l27.476-15.863c1.678-.968,3.038-.183,3.038,1.753Z",
    transform: "translate(-561.484 -248.462)",
    fill: "#ff5d73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10029",
    "data-name": "Path 10029",
    d: "M621.564,282.079l-58.813,33.956v-35.92a6.715,6.715,0,0,1,3.038-5.261l18.157-10.483a2.058,2.058,0,0,1,2.286-.122l2.534,1.881a2.056,2.056,0,0,0,2.286-.122l27.476-15.864c1.677-.968,3.037-.183,3.037,1.754Z",
    transform: "translate(-561.795 -248.773)",
    fill: "#ff7f8e"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10030",
    "data-name": "Path 10030",
    d: "M586.364,360.813,664.676,315.6V257.632l-78.312,45.214Z",
    transform: "translate(-523.968 -221.609)",
    fill: "#7076a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10031",
    "data-name": "Path 10031",
    d: "M664.676,257.632h-3.451l-74.861,43.221v1.991Z",
    transform: "translate(-523.968 -221.609)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10032",
    "data-name": "Path 10032",
    d: "M566.084,305.832v-1.991l-58.947-34.033h-3.449Z",
    transform: "translate(-503.688 -224.595)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10033",
    "data-name": "Path 10033",
    d: "M534.268,302.978a2.529,2.529,0,0,0-.329,1.352v5.546a5.3,5.3,0,0,0,2.213,4.228l14.043,8.109a1.884,1.884,0,0,0,.734.254,1.282,1.282,0,0,1-1.884.321L535,314.679a5.3,5.3,0,0,1-2.214-4.229v-5.545C532.789,303.619,533.407,302.886,534.268,302.978Z",
    transform: "translate(-510.826 -232.73)",
    fill: "#cdd4ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10034",
    "data-name": "Path 10034",
    d: "M503.688,269.808v57.968l62.4,36.024V305.832Zm21.963,26.962c0-1.629.991-2.379,2.214-1.673l14.044,8.109a5.3,5.3,0,0,1,2.213,4.229v5.545c0,1.629-.991,2.379-2.213,1.673l-14.044-8.109a5.3,5.3,0,0,1-2.214-4.229Z",
    transform: "translate(-503.688 -224.595)",
    fill: "#636094"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5518",
    "data-name": "Group 5518",
    transform: "translate(18.291 83.943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10035",
    "data-name": "Path 10035",
    d: "M527.923,338.169l24.555,14.177V335.3l-24.555-14.177Z",
    transform: "translate(-527.923 -321.127)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5516",
    "data-name": "Group 5516",
    transform: "translate(3.068 5.601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10036",
    "data-name": "Path 10036",
    d: "M531.988,329.212l18.42,10.635v-.664l-18.42-10.635Z",
    transform: "translate(-531.988 -328.549)",
    fill: "#8187b2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5517",
    "data-name": "Group 5517",
    transform: "translate(3.068 10.296)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10037",
    "data-name": "Path 10037",
    d: "M531.988,335.432l18.42,10.635V345.4l-18.42-10.635Z",
    transform: "translate(-531.988 -334.769)",
    fill: "#8187b2"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10038",
    "data-name": "Path 10038",
    d: "M622.96,322.63v19.5l31.016-17.907v-19.5Z",
    transform: "translate(-532.945 -233.16)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10039",
    "data-name": "Path 10039",
    d: "M630.728,336.634v.918l19.291-11.138V325.5Z",
    transform: "translate(-534.851 -238.255)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10040",
    "data-name": "Path 10040",
    d: "M630.728,329.479v.918l19.291-11.138v-.918Z",
    transform: "translate(-534.851 -236.5)",
    fill: "#8187b2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10041",
    "data-name": "Path 10041",
    d: "M501.682,248.97,581.5,202.887l63.905,36.9-79.819,46.083Z",
    transform: "translate(-501.682 -202.887)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10042",
    "data-name": "Path 10042",
    d: "M501.682,263.949V271.5l63.905,36.9v-7.547Z",
    transform: "translate(-501.682 -217.865)",
    fill: "#b7bbd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10043",
    "data-name": "Path 10043",
    d: "M586.358,297.858v7.547l79.819-46.083v-7.547Z",
    transform: "translate(-522.453 -214.879)",
    fill: "#cdd4ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5536",
    "data-name": "Group 5536",
    transform: "translate(313.187 82.865)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10044",
    "data-name": "Path 10044",
    d: "M582.413,284.264l-66.885-38.616,53.293-27,66.885,34.843Z",
    transform: "translate(-515.526 -169.141)",
    fill: "#636094"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10045",
    "data-name": "Path 10045",
    d: "M568.821,153.049V202.56l-53.293,27V183.817Z",
    transform: "translate(-515.526 -153.049)",
    fill: "#7076a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10046",
    "data-name": "Path 10046",
    d: "M586.142,202.56l56.133,32.408,10.752-43.3-66.885-38.616Z",
    transform: "translate(-532.848 -153.049)",
    fill: "#636094"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10047",
    "data-name": "Path 10047",
    d: "M568.821,153.049l-53.293,30.768,66.885,38.616,53.293-30.768Zm-50.347,30.768,50.348-29.068,63.939,36.915-50.348,29.068Z",
    transform: "translate(-515.526 -153.049)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5524",
    "data-name": "Group 5524",
    transform: "translate(51.842 0.499)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5521",
    "data-name": "Group 5521",
    transform: "translate(6.535)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10048",
    "data-name": "Path 10048",
    d: "M644.193,215.242l-50.233-29V155.561c0-1.654,1.161-2.324,2.594-1.5l9.141,5.277a5.423,5.423,0,0,1,1.952,2.15l2.164,4.1a5.425,5.425,0,0,0,1.952,2.151L641.6,184.971a5.735,5.735,0,0,1,2.595,4.493Z",
    transform: "translate(-593.143 -153.709)",
    fill: "#ffb236"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10049",
    "data-name": "Path 10049",
    d: "M643.11,216.325l-50.233-29V156.644c0-1.654,1.161-2.325,2.595-1.5l9.14,5.278a5.407,5.407,0,0,1,1.952,2.15l2.164,4.1a5.412,5.412,0,0,0,1.952,2.15l29.835,17.225a5.734,5.734,0,0,1,2.594,4.493Z",
    transform: "translate(-592.877 -153.975)",
    fill: "#ffdd57"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5522",
    "data-name": "Group 5522",
    transform: "translate(7.75 9.444)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10050",
    "data-name": "Path 10050",
    d: "M596.651,196.138l44.718,25.818V192.041l-44.718-25.818Z",
    transform: "translate(-595.018 -166.223)",
    fill: "#dce7f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10051",
    "data-name": "Path 10051",
    d: "M594.487,198.3,639.2,224.12V194.206l-44.718-25.818Z",
    transform: "translate(-594.487 -166.754)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10052",
    "data-name": "Path 10052",
    d: "M594.487,167.857l1.634-1.634,44.718,25.818-1.634,1.634Z",
    transform: "translate(-594.487 -166.223)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5523",
    "data-name": "Group 5523",
    transform: "translate(0 11.437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10053",
    "data-name": "Path 10053",
    d: "M585.3,196.494l50.233,29V194.816a5.732,5.732,0,0,0-2.595-4.493l-15.508-8.954a1.755,1.755,0,0,0-1.952-.1l-2.164,1.606a1.755,1.755,0,0,1-1.952-.1l-23.468-13.549c-1.432-.827-2.594-.156-2.594,1.5Z",
    transform: "translate(-584.483 -168.864)",
    fill: "#ffb236"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10054",
    "data-name": "Path 10054",
    d: "M584.218,214.76l50.232,29V195.9a5.735,5.735,0,0,0-2.594-4.493l-15.508-8.954a1.758,1.758,0,0,0-1.952-.1l-2.164,1.607a1.757,1.757,0,0,1-1.952-.1L586.812,170.3c-1.433-.827-2.594-.157-2.594,1.5Z",
    transform: "translate(-584.218 -169.129)",
    fill: "#ffdd57"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5528",
    "data-name": "Group 5528",
    transform: "translate(31.875 7.618)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5525",
    "data-name": "Group 5525",
    transform: "translate(6.535)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10055",
    "data-name": "Path 10055",
    d: "M617.736,234.987l-50.233-29V165c0-1.654,1.161-2.324,2.594-1.5l9.141,5.277a5.428,5.428,0,0,1,1.952,2.15l2.164,4.106a5.428,5.428,0,0,0,1.952,2.15l29.835,17.225a5.732,5.732,0,0,1,2.595,4.493Z",
    transform: "translate(-566.686 -163.143)",
    fill: "#ff5d73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10056",
    "data-name": "Path 10056",
    d: "M616.653,236.07l-50.233-29v-40.99c0-1.654,1.161-2.325,2.595-1.5l9.14,5.278a5.412,5.412,0,0,1,1.952,2.15l2.164,4.1a5.412,5.412,0,0,0,1.952,2.15l29.835,17.225a5.735,5.735,0,0,1,2.594,4.493Z",
    transform: "translate(-566.42 -163.409)",
    fill: "#ff7f8e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5526",
    "data-name": "Group 5526",
    transform: "translate(8.476 8.792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10057",
    "data-name": "Path 10057",
    d: "M571.157,215.019l44.718,25.818V200.611l-44.718-25.818Z",
    transform: "translate(-569.523 -174.793)",
    fill: "#dce7f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10058",
    "data-name": "Path 10058",
    d: "M568.992,206.873l44.718,25.818V202.776l-44.718-25.818Z",
    transform: "translate(-568.992 -175.324)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10059",
    "data-name": "Path 10059",
    d: "M568.992,176.427l1.634-1.634,44.718,25.818-1.634,1.634Z",
    transform: "translate(-568.992 -174.793)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5527",
    "data-name": "Group 5527",
    transform: "translate(0 11.437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10060",
    "data-name": "Path 10060",
    d: "M558.843,205.928l50.233,29V204.25a5.732,5.732,0,0,0-2.595-4.493L590.974,190.8a1.757,1.757,0,0,0-1.952-.1l-2.164,1.606a1.755,1.755,0,0,1-1.952-.1l-23.468-13.549c-1.432-.827-2.594-.156-2.594,1.5Z",
    transform: "translate(-558.026 -178.298)",
    fill: "#ff5d73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10061",
    "data-name": "Path 10061",
    d: "M557.761,207.01l50.232,29V205.333a5.735,5.735,0,0,0-2.594-4.493l-15.508-8.954a1.758,1.758,0,0,0-1.952-.1l-2.164,1.607a1.758,1.758,0,0,1-1.952-.1l-23.468-13.549c-1.433-.827-2.594-.157-2.594,1.5Z",
    transform: "translate(-557.761 -178.563)",
    fill: "#ff7f8e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5532",
    "data-name": "Group 5532",
    transform: "translate(17.364 16.572)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5529",
    "data-name": "Group 5529",
    transform: "translate(6.536)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10062",
    "data-name": "Path 10062",
    d: "M598.508,236.54l-50.233-29V176.859c0-1.654,1.161-2.325,2.595-1.5l9.14,5.278a5.412,5.412,0,0,1,1.952,2.15l2.164,4.1a5.422,5.422,0,0,0,1.952,2.15l29.836,17.225a5.735,5.735,0,0,1,2.594,4.494Z",
    transform: "translate(-547.458 -175.007)",
    fill: "#9588ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10063",
    "data-name": "Path 10063",
    d: "M597.426,237.622l-50.233-29V177.941c0-1.654,1.161-2.324,2.594-1.5l9.141,5.277a5.428,5.428,0,0,1,1.952,2.15l2.164,4.106a5.428,5.428,0,0,0,1.953,2.15l29.835,17.225a5.732,5.732,0,0,1,2.595,4.493Z",
    transform: "translate(-547.193 -175.272)",
    fill: "#a299ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5530",
    "data-name": "Group 5530",
    transform: "translate(7.003 8.792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10064",
    "data-name": "Path 10064",
    d: "M551.929,216.571l44.718,25.818V212.474l-44.718-25.818Z",
    transform: "translate(-548.822 -186.657)",
    fill: "#dce7f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10065",
    "data-name": "Path 10065",
    d: "M547.813,219.387,592.53,245.2V215.29l-44.718-25.818Z",
    transform: "translate(-547.813 -187.347)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10066",
    "data-name": "Path 10066",
    d: "M547.813,188.782l3.107-2.125,44.718,25.818L592.53,214.6Z",
    transform: "translate(-547.813 -186.657)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5531",
    "data-name": "Group 5531",
    transform: "translate(0 11.437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10067",
    "data-name": "Path 10067",
    d: "M539.615,217.791l50.233,29V216.114a5.735,5.735,0,0,0-2.594-4.493l-15.508-8.954a1.758,1.758,0,0,0-1.952-.1l-2.164,1.607a1.758,1.758,0,0,1-1.952-.1L542.21,190.516c-1.433-.827-2.595-.157-2.595,1.5Z",
    transform: "translate(-538.798 -190.161)",
    fill: "#9588ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10068",
    "data-name": "Path 10068",
    d: "M538.533,218.874l50.233,29V217.2a5.733,5.733,0,0,0-2.595-4.493l-15.508-8.954a1.757,1.757,0,0,0-1.952-.1l-2.165,1.606a1.757,1.757,0,0,1-1.952-.1L541.127,191.6c-1.432-.827-2.594-.156-2.594,1.5Z",
    transform: "translate(-538.533 -190.427)",
    fill: "#a299ff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10069",
    "data-name": "Path 10069",
    d: "M582.412,278.171l-66.887-38.617V193.817l66.887,38.617Z",
    transform: "translate(-515.525 -163.049)",
    fill: "#636094"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10070",
    "data-name": "Path 10070",
    d: "M515.525,193.817h2.948l63.939,36.916v1.7Z",
    transform: "translate(-515.525 -163.049)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10071",
    "data-name": "Path 10071",
    d: "M604.152,234.985v-1.7L654.5,204.216h2.946Z",
    transform: "translate(-537.265 -165.6)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10072",
    "data-name": "Path 10072",
    d: "M643.612,232.548a2.165,2.165,0,0,1,.281,1.155v4.736A4.525,4.525,0,0,1,642,242.05l-11.995,6.926a1.606,1.606,0,0,1-.627.217,1.094,1.094,0,0,0,1.609.274l12-6.925a4.527,4.527,0,0,0,1.89-3.611v-4.737C644.875,233.095,644.347,232.469,643.612,232.548Z",
    transform: "translate(-543.454 -172.548)",
    fill: "#b7bbd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10073",
    "data-name": "Path 10073",
    d: "M604.152,234.984v45.738l53.293-30.769V204.216Zm34.534-3a4.527,4.527,0,0,1-1.89,3.611l-12,6.925c-1.044.6-1.891-.037-1.891-1.429v-4.737a4.528,4.528,0,0,1,1.891-3.611l12-6.925c1.044-.6,1.89.037,1.89,1.429Z",
    transform: "translate(-537.265 -165.6)",
    fill: "#7076a5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5535",
    "data-name": "Group 5535",
    transform: "translate(83.585 71.696)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10074",
    "data-name": "Path 10074",
    d: "M647.25,262.6l-20.973,12.109V260.157l20.973-12.109Z",
    transform: "translate(-626.277 -248.048)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5533",
    "data-name": "Group 5533",
    transform: "translate(2.62 4.784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10075",
    "data-name": "Path 10075",
    d: "M645.482,254.954l-15.733,9.083v-.567l15.733-9.083Z",
    transform: "translate(-629.749 -254.387)",
    fill: "#8187b2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5534",
    "data-name": "Group 5534",
    transform: "translate(2.62 8.794)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10076",
    "data-name": "Path 10076",
    d: "M645.482,260.267l-15.733,9.083v-.567l15.733-9.083Z",
    transform: "translate(-629.749 -259.7)",
    fill: "#8187b2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5552",
    "data-name": "Group 5552",
    transform: "translate(90.628 47.142)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10077",
    "data-name": "Path 10077",
    d: "M273.922,236.931l66.885-38.616-53.293-27-66.885,34.843Z",
    transform: "translate(-220.629 -121.808)",
    fill: "#636094"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10078",
    "data-name": "Path 10078",
    d: "M309.254,105.716v49.511l53.293,27V136.485Z",
    transform: "translate(-242.368 -105.716)",
    fill: "#7076a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10079",
    "data-name": "Path 10079",
    d: "M287.514,155.227l-56.133,32.408-10.752-43.3,66.885-38.616Z",
    transform: "translate(-220.629 -105.716)",
    fill: "#636094"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10080",
    "data-name": "Path 10080",
    d: "M220.629,144.332,273.922,175.1l66.885-38.617-53.293-30.768ZM273.922,173.4l-50.348-29.068,63.94-36.915,50.347,29.067Z",
    transform: "translate(-220.629 -105.716)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5540",
    "data-name": "Group 5540",
    transform: "translate(10.752 0.498)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5537",
    "data-name": "Group 5537"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10081",
    "data-name": "Path 10081",
    d: "M234.876,167.91l50.233-29V108.228c0-1.654-1.161-2.324-2.594-1.5l-9.141,5.278a5.418,5.418,0,0,0-1.952,2.15l-2.164,4.1a5.423,5.423,0,0,1-1.952,2.15l-29.835,17.225a5.732,5.732,0,0,0-2.595,4.493Z",
    transform: "translate(-234.876 -106.376)",
    fill: "#cdd4ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10082",
    "data-name": "Path 10082",
    d: "M235.959,168.992l50.233-29V109.311c0-1.654-1.161-2.325-2.595-1.5l-9.14,5.278a5.412,5.412,0,0,0-1.952,2.15l-2.164,4.1a5.411,5.411,0,0,1-1.952,2.15l-29.836,17.225a5.735,5.735,0,0,0-2.594,4.493Z",
    transform: "translate(-235.142 -106.642)",
    fill: "#f7f7f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5538",
    "data-name": "Group 5538",
    transform: "translate(3.484 9.444)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10083",
    "data-name": "Path 10083",
    d: "M284.21,148.8l-44.718,25.818V144.708L284.21,118.89Z",
    transform: "translate(-239.493 -118.89)",
    fill: "#dce7f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10084",
    "data-name": "Path 10084",
    d: "M286.375,150.97l-44.718,25.818V146.873l44.718-25.818Z",
    transform: "translate(-240.024 -119.421)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10085",
    "data-name": "Path 10085",
    d: "M285.844,120.524l-1.634-1.634-44.718,25.818,1.634,1.634Z",
    transform: "translate(-239.493 -118.89)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5539",
    "data-name": "Group 5539",
    transform: "translate(6.536 11.437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10086",
    "data-name": "Path 10086",
    d: "M293.769,149.161l-50.233,29V147.484a5.733,5.733,0,0,1,2.595-4.494l15.508-8.954a1.758,1.758,0,0,1,1.952-.1l2.164,1.606a1.755,1.755,0,0,0,1.952-.1l23.467-13.548c1.432-.828,2.594-.157,2.594,1.5Z",
    transform: "translate(-243.536 -121.531)",
    fill: "#cdd4ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10087",
    "data-name": "Path 10087",
    d: "M294.852,167.428l-50.233,29V148.566a5.736,5.736,0,0,1,2.594-4.493l15.508-8.953a1.755,1.755,0,0,1,1.952-.1l2.164,1.606a1.758,1.758,0,0,0,1.952-.1l23.467-13.549c1.433-.827,2.595-.157,2.595,1.5Z",
    transform: "translate(-243.802 -121.797)",
    fill: "#f7f7f9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5544",
    "data-name": "Group 5544",
    transform: "translate(30.719 7.618)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5541",
    "data-name": "Group 5541"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10088",
    "data-name": "Path 10088",
    d: "M261.333,187.655l50.233-29v-40.99c0-1.654-1.161-2.325-2.594-1.5l-9.141,5.278a5.423,5.423,0,0,0-1.952,2.15l-2.164,4.1a5.423,5.423,0,0,1-1.952,2.15l-29.835,17.225a5.734,5.734,0,0,0-2.595,4.493Z",
    transform: "translate(-261.333 -115.811)",
    fill: "#ffb236"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10089",
    "data-name": "Path 10089",
    d: "M262.416,188.737l50.233-29v-40.99c0-1.654-1.161-2.324-2.595-1.5l-9.14,5.277a5.417,5.417,0,0,0-1.952,2.15L296.8,128.78a5.421,5.421,0,0,1-1.952,2.15L265.01,148.155a5.736,5.736,0,0,0-2.594,4.493Z",
    transform: "translate(-261.599 -116.076)",
    fill: "#ffdd57"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5542",
    "data-name": "Group 5542",
    transform: "translate(2.758 8.792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10090",
    "data-name": "Path 10090",
    d: "M309.7,167.686,264.987,193.5V153.278L309.7,127.461Z",
    transform: "translate(-264.987 -127.461)",
    fill: "#dce7f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10091",
    "data-name": "Path 10091",
    d: "M311.87,159.54l-44.718,25.818V155.443l44.718-25.818Z",
    transform: "translate(-265.518 -127.992)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10092",
    "data-name": "Path 10092",
    d: "M311.339,129.095l-1.634-1.634-44.718,25.818,1.634,1.634Z",
    transform: "translate(-264.987 -127.461)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5543",
    "data-name": "Group 5543",
    transform: "translate(6.536 11.437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10093",
    "data-name": "Path 10093",
    d: "M320.226,158.595l-50.233,29V156.918a5.734,5.734,0,0,1,2.595-4.493l15.508-8.954a1.758,1.758,0,0,1,1.952-.1l2.164,1.607a1.758,1.758,0,0,0,1.952-.1l23.467-13.549c1.432-.827,2.594-.157,2.594,1.5Z",
    transform: "translate(-269.993 -130.965)",
    fill: "#ffb236"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10094",
    "data-name": "Path 10094",
    d: "M321.309,159.678l-50.233,29V158a5.734,5.734,0,0,1,2.594-4.493l15.508-8.954a1.757,1.757,0,0,1,1.952-.1l2.164,1.606a1.757,1.757,0,0,0,1.952-.1L318.714,132.4c1.433-.827,2.595-.156,2.595,1.5Z",
    transform: "translate(-270.259 -131.231)",
    fill: "#ffdd57"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5548",
    "data-name": "Group 5548",
    transform: "translate(45.231 16.572)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5545",
    "data-name": "Group 5545"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10095",
    "data-name": "Path 10095",
    d: "M280.561,189.207l50.233-29V129.526c0-1.654-1.161-2.325-2.595-1.5l-9.14,5.277a5.423,5.423,0,0,0-1.952,2.15l-2.164,4.1a5.418,5.418,0,0,1-1.952,2.15l-29.836,17.225a5.736,5.736,0,0,0-2.594,4.493Z",
    transform: "translate(-280.561 -127.674)",
    fill: "#ff5d73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10096",
    "data-name": "Path 10096",
    d: "M281.643,190.29l50.233-29V130.608c0-1.654-1.161-2.324-2.594-1.5l-9.141,5.278a5.418,5.418,0,0,0-1.952,2.15l-2.164,4.1a5.423,5.423,0,0,1-1.952,2.15l-29.835,17.225a5.732,5.732,0,0,0-2.595,4.493Z",
    transform: "translate(-280.826 -127.94)",
    fill: "#ff7f8e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5546",
    "data-name": "Group 5546",
    transform: "translate(2.758 8.792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10097",
    "data-name": "Path 10097",
    d: "M328.932,169.239l-44.718,25.818V165.142l44.718-25.818Z",
    transform: "translate(-284.215 -139.324)",
    fill: "#dce7f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10098",
    "data-name": "Path 10098",
    d: "M333.049,172.054l-44.718,25.818V167.957l44.718-25.818Z",
    transform: "translate(-285.225 -140.015)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10099",
    "data-name": "Path 10099",
    d: "M332.039,141.449l-3.107-2.125-44.718,25.818,3.107,2.125Z",
    transform: "translate(-284.215 -139.324)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5547",
    "data-name": "Group 5547",
    transform: "translate(6.536 11.437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10100",
    "data-name": "Path 10100",
    d: "M339.454,170.459l-50.233,29V168.781a5.734,5.734,0,0,1,2.594-4.493l15.508-8.954a1.755,1.755,0,0,1,1.952-.1l2.164,1.606a1.757,1.757,0,0,0,1.952-.1l23.467-13.549c1.433-.827,2.595-.156,2.595,1.5Z",
    transform: "translate(-289.221 -142.829)",
    fill: "#ff5d73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10101",
    "data-name": "Path 10101",
    d: "M340.536,171.541l-50.233,29V169.864a5.734,5.734,0,0,1,2.595-4.493l15.508-8.954a1.757,1.757,0,0,1,1.952-.1l2.164,1.606a1.755,1.755,0,0,0,1.952-.1l23.467-13.548c1.432-.827,2.594-.157,2.594,1.5Z",
    transform: "translate(-289.486 -143.094)",
    fill: "#ff7f8e"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10102",
    "data-name": "Path 10102",
    d: "M291.244,230.839l66.887-38.617V146.484L291.244,185.1Z",
    transform: "translate(-237.951 -115.716)",
    fill: "#636094"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10103",
    "data-name": "Path 10103",
    d: "M358.131,146.484h-2.948L291.244,183.4v1.7Z",
    transform: "translate(-237.951 -115.716)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10104",
    "data-name": "Path 10104",
    d: "M273.922,187.652v-1.7l-50.347-29.068h-2.946Z",
    transform: "translate(-220.629 -118.267)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10105",
    "data-name": "Path 10105",
    d: "M246.748,185.215a2.162,2.162,0,0,0-.282,1.155v4.736a4.528,4.528,0,0,0,1.891,3.611l11.994,6.925a1.621,1.621,0,0,0,.627.217,1.1,1.1,0,0,1-1.609.274l-11.994-6.926a4.524,4.524,0,0,1-1.891-3.611v-4.736C245.485,185.763,246.013,185.136,246.748,185.215Z",
    transform: "translate(-226.726 -125.215)",
    fill: "#b7bbd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10106",
    "data-name": "Path 10106",
    d: "M220.629,156.883v45.738l53.293,30.768V187.652Zm18.759,23.03c0-1.392.846-2.032,1.891-1.429l11.994,6.925a4.527,4.527,0,0,1,1.891,3.611v4.736c0,1.392-.847,2.032-1.891,1.429l-11.994-6.926a4.524,4.524,0,0,1-1.891-3.611Z",
    transform: "translate(-220.629 -118.267)",
    fill: "#7076a5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5551",
    "data-name": "Group 5551",
    transform: "translate(15.622 71.696)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10107",
    "data-name": "Path 10107",
    d: "M241.329,215.272,262.3,227.38V212.824l-20.973-12.109Z",
    transform: "translate(-241.329 -200.716)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5549",
    "data-name": "Group 5549",
    transform: "translate(2.62 4.784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10108",
    "data-name": "Path 10108",
    d: "M244.8,207.622l15.733,9.083v-.567L244.8,207.055Z",
    transform: "translate(-244.801 -207.055)",
    fill: "#8187b2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5550",
    "data-name": "Group 5550",
    transform: "translate(2.62 8.794)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10109",
    "data-name": "Path 10109",
    d: "M244.8,212.934l15.733,9.083v-.567L244.8,212.367Z",
    transform: "translate(-244.801 -212.367)",
    fill: "#8187b2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5571",
    "data-name": "Group 5571",
    transform: "translate(134.651 51.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10110",
    "data-name": "Path 10110",
    d: "M478.565,313.084l-98.039,56.6V226.759l98.039-56.6Z",
    transform: "translate(-303.875 -125.903)",
    fill: "#7076a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10111",
    "data-name": "Path 10111",
    d: "M459,322.924l73.1,42.238V330.768l-43.317-25.041Z",
    transform: "translate(-323.125 -159.158)",
    fill: "#636094"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10112",
    "data-name": "Path 10112",
    d: "M453.652,155.773l-98.039,56.6-76.649-44.253L377,111.52Z",
    transform: "translate(-278.962 -111.52)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10113",
    "data-name": "Path 10113",
    d: "M355.612,373.7l-76.651-44.254V186.519l76.651,44.254Z",
    transform: "translate(-278.962 -129.917)",
    fill: "#636094"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10114",
    "data-name": "Path 10114",
    d: "M475.159,220.935l-87.948,50.777V232.718l87.948-50.777Z",
    transform: "translate(-305.515 -128.794)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10115",
    "data-name": "Path 10115",
    d: "M387.212,398.787l37.768,21.805,87.494-51.043-71.082-41.035-54.179,31.28Z",
    transform: "translate(-305.515 -164.748)",
    fill: "#636094"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10116",
    "data-name": "Path 10116",
    d: "M539.207,333.415l3.107-1.794-44.85-25.894-3.087,1.811Z",
    transform: "translate(-331.803 -159.158)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5554",
    "data-name": "Group 5554",
    transform: "translate(113.791 78.011)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10117",
    "data-name": "Path 10117",
    d: "M431.335,241.133c-.8,0-1.6-.645-1.6-2.087v-8.953a4.793,4.793,0,0,1,2.051-3.871L450.93,215.17a1.946,1.946,0,0,1,.97-.284c.795,0,1.6.645,1.6,2.086v8.954a4.8,4.8,0,0,1-2.05,3.872L432.3,240.849A1.948,1.948,0,0,1,431.335,241.133Z",
    transform: "translate(-429.737 -214.886)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5553",
    "data-name": "Group 5553",
    transform: "translate(1.494 1.749)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10118",
    "data-name": "Path 10118",
    d: "M452.488,217.785c0-.518-.365-.73-.814-.47l-19.142,11.052a1.8,1.8,0,0,0-.814,1.411v3.748l20.771-11.992Z",
    transform: "translate(-431.717 -217.204)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10119",
    "data-name": "Path 10119",
    d: "M431.717,234.932v5.846c0,.518.365.729.814.47L451.674,230.2a1.8,1.8,0,0,0,.814-1.411V222.94Z",
    transform: "translate(-431.717 -218.611)",
    fill: "#b7bbd1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10120",
    "data-name": "Path 10120",
    d: "M452.488,223.565l-20.771,11.992v-1.852l20.771-11.992Z",
    transform: "translate(-430.223 -216.561)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10121",
    "data-name": "Path 10121",
    d: "M458.027,229.8l-3.732-4.3,4.21-2.554v5.775Z",
    transform: "translate(-435.761 -216.862)",
    fill: "#8187b2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5558",
    "data-name": "Group 5558",
    transform: "translate(95.438 148.379)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5555",
    "data-name": "Group 5555"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10122",
    "data-name": "Path 10122",
    d: "M405.419,380.17l58.813-33.956v-35.92c0-1.937-1.359-2.722-3.037-1.753l-10.7,6.179a6.346,6.346,0,0,0-2.285,2.518l-2.534,4.806a6.358,6.358,0,0,1-2.286,2.518l-34.931,20.167a6.713,6.713,0,0,0-3.038,5.261Z",
    transform: "translate(-405.419 -308.126)",
    fill: "#9588ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10123",
    "data-name": "Path 10123",
    d: "M406.687,381.437,465.5,347.481V311.562c0-1.937-1.36-2.722-3.038-1.754l-10.7,6.179a6.342,6.342,0,0,0-2.286,2.518l-2.534,4.806a6.342,6.342,0,0,1-2.286,2.518L409.724,346a6.716,6.716,0,0,0-3.037,5.261Z",
    transform: "translate(-405.73 -308.437)",
    fill: "#a299ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5556",
    "data-name": "Group 5556",
    transform: "translate(3.229 10.294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10124",
    "data-name": "Path 10124",
    d: "M462.053,356.79,409.7,387.018V351.994l52.356-30.228Z",
    transform: "translate(-409.697 -321.766)",
    fill: "#dce7f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10125",
    "data-name": "Path 10125",
    d: "M464.588,359.325l-52.356,30.228V354.529L464.588,324.3Z",
    transform: "translate(-410.319 -322.388)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10126",
    "data-name": "Path 10126",
    d: "M463.966,323.679l-1.913-1.913L409.7,351.994l1.913,1.913Z",
    transform: "translate(-409.697 -321.766)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5557",
    "data-name": "Group 5557",
    transform: "translate(7.653 13.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10127",
    "data-name": "Path 10127",
    d: "M474.372,358.219l-58.813,33.956V356.255a6.712,6.712,0,0,1,3.037-5.261l18.157-10.483a2.058,2.058,0,0,1,2.286-.122l2.534,1.881a2.056,2.056,0,0,0,2.285-.122l27.476-15.863c1.678-.968,3.038-.183,3.038,1.753Z",
    transform: "translate(-415.559 -325.869)",
    fill: "#9588ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10128",
    "data-name": "Path 10128",
    d: "M475.639,359.486l-58.813,33.956v-35.92a6.716,6.716,0,0,1,3.037-5.261l18.157-10.483a2.058,2.058,0,0,1,2.286-.122l2.534,1.881a2.056,2.056,0,0,0,2.286-.122L472.6,327.551c1.678-.968,3.038-.183,3.038,1.754Z",
    transform: "translate(-415.87 -326.18)",
    fill: "#a299ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5562",
    "data-name": "Group 5562",
    transform: "translate(109.809 151.829)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5559",
    "data-name": "Group 5559"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10129",
    "data-name": "Path 10129",
    d: "M424.462,384.74l58.813-33.956v-35.92c0-1.937-1.36-2.721-3.038-1.753l-10.7,6.179a6.342,6.342,0,0,0-2.286,2.518l-2.534,4.806a6.341,6.341,0,0,1-2.286,2.518L427.5,349.3a6.714,6.714,0,0,0-3.037,5.261Z",
    transform: "translate(-424.462 -312.696)",
    fill: "#ff5d73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10130",
    "data-name": "Path 10130",
    d: "M425.729,386.008l58.813-33.956V316.132c0-1.937-1.36-2.722-3.037-1.754l-10.7,6.179a6.351,6.351,0,0,0-2.285,2.518l-2.534,4.806A6.353,6.353,0,0,1,463.7,330.4l-34.931,20.168a6.713,6.713,0,0,0-3.038,5.26Z",
    transform: "translate(-424.773 -313.007)",
    fill: "#ff7f8e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5560",
    "data-name": "Group 5560",
    transform: "translate(3.229 10.294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10131",
    "data-name": "Path 10131",
    d: "M481.1,361.361,428.74,391.588V356.564L481.1,326.336Z",
    transform: "translate(-428.74 -326.336)",
    fill: "#dce7f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10132",
    "data-name": "Path 10132",
    d: "M483.631,363.9l-52.356,30.228V359.1l52.356-30.228Z",
    transform: "translate(-429.362 -326.958)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10133",
    "data-name": "Path 10133",
    d: "M483.009,328.249l-1.913-1.913L428.74,356.564l1.913,1.913Z",
    transform: "translate(-428.74 -326.336)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5561",
    "data-name": "Group 5561",
    transform: "translate(7.652 13.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10134",
    "data-name": "Path 10134",
    d: "M493.414,362.789,434.6,396.744V360.825a6.714,6.714,0,0,1,3.038-5.261L455.8,345.081a2.058,2.058,0,0,1,2.286-.122l2.534,1.881a2.056,2.056,0,0,0,2.286-.122l27.476-15.863c1.677-.968,3.037-.183,3.037,1.754Z",
    transform: "translate(-434.601 -330.439)",
    fill: "#ff5d73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10135",
    "data-name": "Path 10135",
    d: "M494.681,364.056l-58.813,33.956v-35.92a6.713,6.713,0,0,1,3.038-5.26l18.157-10.484a2.056,2.056,0,0,1,2.286-.121l2.534,1.881a2.056,2.056,0,0,0,2.285-.122l27.476-15.863c1.678-.969,3.037-.183,3.037,1.753Z",
    transform: "translate(-434.912 -330.75)",
    fill: "#ff7f8e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5566",
    "data-name": "Group 5566",
    transform: "translate(124.756 158.727)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5563",
    "data-name": "Group 5563"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10136",
    "data-name": "Path 10136",
    d: "M444.266,393.881l58.813-33.956V324.005c0-1.937-1.36-2.722-3.037-1.754l-10.7,6.179a6.358,6.358,0,0,0-2.286,2.518l-2.534,4.806a6.346,6.346,0,0,1-2.285,2.518L447.3,358.439a6.713,6.713,0,0,0-3.038,5.26Z",
    transform: "translate(-444.266 -321.836)",
    fill: "#ffb236"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10137",
    "data-name": "Path 10137",
    d: "M445.533,395.148l58.813-33.956v-35.92c0-1.937-1.36-2.721-3.038-1.753l-10.7,6.179a6.344,6.344,0,0,0-2.286,2.517l-2.534,4.807a6.345,6.345,0,0,1-2.286,2.517l-34.931,20.168a6.713,6.713,0,0,0-3.038,5.261Z",
    transform: "translate(-444.577 -322.147)",
    fill: "#ffdd57"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5564",
    "data-name": "Group 5564",
    transform: "translate(4.079 11.058)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10138",
    "data-name": "Path 10138",
    d: "M502.027,371.512,449.671,401.74V366.716l52.356-30.228Z",
    transform: "translate(-449.671 -336.488)",
    fill: "#dce7f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10139",
    "data-name": "Path 10139",
    d: "M504.562,374.047l-52.356,30.228V369.251l52.356-30.228Z",
    transform: "translate(-450.293 -337.11)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10140",
    "data-name": "Path 10140",
    d: "M503.94,338.4l-1.913-1.913-52.356,30.228,1.913,1.913Z",
    transform: "translate(-449.671 -336.488)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5565",
    "data-name": "Group 5565",
    transform: "translate(7.652 13.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10141",
    "data-name": "Path 10141",
    d: "M513.218,371.929,454.4,405.885v-35.92a6.713,6.713,0,0,1,3.038-5.26L475.6,354.221a2.055,2.055,0,0,1,2.285-.122l2.534,1.881a2.058,2.058,0,0,0,2.286-.122L510.181,340c1.677-.969,3.037-.183,3.037,1.753Z",
    transform: "translate(-454.405 -339.58)",
    fill: "#ffb236"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10142",
    "data-name": "Path 10142",
    d: "M514.486,373.2l-58.813,33.956V371.233a6.712,6.712,0,0,1,3.037-5.261l18.157-10.483a2.058,2.058,0,0,1,2.286-.122l2.534,1.881a2.058,2.058,0,0,0,2.286-.122l27.476-15.863c1.678-.968,3.038-.183,3.038,1.753Z",
    transform: "translate(-454.716 -339.891)",
    fill: "#ffdd57"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10143",
    "data-name": "Path 10143",
    d: "M437.255,382.345l3.107,1.792,87.948-50.777-3.107-1.794Z",
    transform: "translate(-317.791 -165.497)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10144",
    "data-name": "Path 10144",
    d: "M387.212,410.449l40.867,23.595V399.649l-40.867-23.595Z",
    transform: "translate(-305.515 -176.409)",
    fill: "#b7bbd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10145",
    "data-name": "Path 10145",
    d: "M428.087,398.481l3.107-1.794-43.982-25.393v3.592Z",
    transform: "translate(-305.515 -175.242)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10146",
    "data-name": "Path 10146",
    d: "M475.159,281.3l-87.948,50.777V293.087l87.948-50.776Z",
    transform: "translate(-305.515 -143.603)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5568",
    "data-name": "Group 5568",
    transform: "translate(113.791 125.046)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10147",
    "data-name": "Path 10147",
    d: "M431.335,303.456c-.8,0-1.6-.645-1.6-2.087v-8.953a4.8,4.8,0,0,1,2.051-3.872l19.142-11.052a1.938,1.938,0,0,1,.97-.284c.795,0,1.6.645,1.6,2.086v8.954a4.794,4.794,0,0,1-2.05,3.871L432.3,303.172A1.942,1.942,0,0,1,431.335,303.456Z",
    transform: "translate(-429.737 -277.209)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5567",
    "data-name": "Group 5567",
    transform: "translate(1.494 1.749)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10148",
    "data-name": "Path 10148",
    d: "M452.488,280.108c0-.518-.365-.73-.814-.47l-19.142,11.051a1.8,1.8,0,0,0-.814,1.411v3.748l20.771-11.992Z",
    transform: "translate(-431.717 -279.527)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10149",
    "data-name": "Path 10149",
    d: "M431.717,297.255V303.1c0,.518.365.729.814.47l19.142-11.052a1.8,1.8,0,0,0,.814-1.411v-5.846Z",
    transform: "translate(-431.717 -280.934)",
    fill: "#b7bbd1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10150",
    "data-name": "Path 10150",
    d: "M452.488,285.888,431.717,297.88v-1.852l20.771-11.992Z",
    transform: "translate(-430.223 -278.884)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10151",
    "data-name": "Path 10151",
    d: "M458.027,292.12l-3.732-4.3,4.21-2.554v5.775Z",
    transform: "translate(-435.761 -279.185)",
    fill: "#8187b2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10152",
    "data-name": "Path 10152",
    d: "M387.212,351.322v-6.567l87.948-50.777v6.567Z",
    transform: "translate(-305.515 -156.276)",
    fill: "#7076a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10153",
    "data-name": "Path 10153",
    d: "M529.32,372.937l-87.948,50.777V384.72l87.948-50.777Z",
    transform: "translate(-318.801 -166.08)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5570",
    "data-name": "Group 5570",
    transform: "translate(154.665 192.727)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10154",
    "data-name": "Path 10154",
    d: "M485.495,393.135c-.795,0-1.6-.645-1.6-2.087V382.1a4.8,4.8,0,0,1,2.051-3.872l19.142-11.052a1.946,1.946,0,0,1,.97-.284c.795,0,1.6.645,1.6,2.086v8.954a4.8,4.8,0,0,1-2.051,3.872l-19.142,11.052A1.946,1.946,0,0,1,485.495,393.135Z",
    transform: "translate(-483.897 -366.888)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5569",
    "data-name": "Group 5569",
    transform: "translate(1.494 1.749)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10155",
    "data-name": "Path 10155",
    d: "M506.649,369.787c0-.518-.366-.73-.815-.47l-19.142,11.051a1.8,1.8,0,0,0-.815,1.411v3.748l20.772-11.992Z",
    transform: "translate(-485.877 -369.206)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10156",
    "data-name": "Path 10156",
    d: "M485.877,386.934v5.846c0,.518.365.729.815.47L505.834,382.2a1.8,1.8,0,0,0,.815-1.411v-5.846Z",
    transform: "translate(-485.877 -370.613)",
    fill: "#b7bbd1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10157",
    "data-name": "Path 10157",
    d: "M506.648,375.567l-20.771,11.992v-1.852l20.771-11.992Z",
    transform: "translate(-484.383 -368.563)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10158",
    "data-name": "Path 10158",
    d: "M512.187,381.8l-3.732-4.3,4.21-2.554v5.775Z",
    transform: "translate(-489.921 -368.864)",
    fill: "#8187b2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10159",
    "data-name": "Path 10159",
    d: "M437.255,398.849v39l3.107,1.789V400.641Z",
    transform: "translate(-317.791 -182.001)",
    fill: "#cdd4ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5588",
    "data-name": "Group 5588",
    transform: "translate(156.345)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5587",
    "data-name": "Group 5587"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10160",
    "data-name": "Path 10160",
    d: "M370.1,201.3l78.31-45.212-62.4-36.024-78.31,45.212Z",
    transform: "translate(-307.706 -62.092)",
    fill: "#636094"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10161",
    "data-name": "Path 10161",
    d: "M411.469,43.251v57.968l62.4,36.024V79.275Z",
    transform: "translate(-333.159 -43.251)",
    fill: "#b7bbd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10162",
    "data-name": "Path 10162",
    d: "M386.016,101.219,320.3,139.163l-12.589-50.7,78.31-45.212Z",
    transform: "translate(-307.706 -43.251)",
    fill: "#e6edf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10163",
    "data-name": "Path 10163",
    d: "M307.706,88.463l62.4,36.025,78.309-45.213-62.4-36.024ZM370.1,122.5,311.155,88.463l74.861-43.22,58.947,34.033Z",
    transform: "translate(-307.706 -43.251)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5575",
    "data-name": "Group 5575",
    transform: "translate(12.589 0.584)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5572",
    "data-name": "Group 5572"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10164",
    "data-name": "Path 10164",
    d: "M324.387,116.068,383.2,82.112V46.192c0-1.937-1.36-2.721-3.037-1.753l-10.7,6.179a6.353,6.353,0,0,0-2.286,2.518l-2.534,4.806a6.346,6.346,0,0,1-2.285,2.518L327.425,80.626a6.713,6.713,0,0,0-3.038,5.261Z",
    transform: "translate(-324.387 -44.024)",
    fill: "#ffb236"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10165",
    "data-name": "Path 10165",
    d: "M325.655,117.336l58.813-33.956V47.46c0-1.937-1.36-2.722-3.038-1.754l-10.7,6.179a6.342,6.342,0,0,0-2.286,2.518l-2.534,4.806a6.342,6.342,0,0,1-2.286,2.518L328.692,81.894a6.712,6.712,0,0,0-3.037,5.26Z",
    transform: "translate(-324.698 -44.335)",
    fill: "#ffdd57"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5573",
    "data-name": "Group 5573",
    transform: "translate(4.079 11.057)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10166",
    "data-name": "Path 10166",
    d: "M382.148,93.7l-52.356,30.228V88.9l52.356-30.228Z",
    transform: "translate(-329.792 -58.676)",
    fill: "#dce7f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10167",
    "data-name": "Path 10167",
    d: "M384.683,96.235l-52.356,30.228V91.438L384.683,61.21Z",
    transform: "translate(-330.414 -59.297)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10168",
    "data-name": "Path 10168",
    d: "M384.061,60.589l-1.913-1.913L329.792,88.9l1.913,1.913Z",
    transform: "translate(-329.792 -58.676)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5574",
    "data-name": "Group 5574",
    transform: "translate(7.652 13.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10169",
    "data-name": "Path 10169",
    d: "M393.339,94.117l-58.813,33.956V92.153a6.713,6.713,0,0,1,3.038-5.261l18.157-10.483a2.057,2.057,0,0,1,2.285-.122l2.534,1.881a2.058,2.058,0,0,0,2.286-.122L390.3,62.182c1.678-.968,3.037-.183,3.037,1.753Z",
    transform: "translate(-334.526 -61.767)",
    fill: "#ffb236"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10170",
    "data-name": "Path 10170",
    d: "M394.607,115.5,335.794,149.46V93.42a6.716,6.716,0,0,1,3.037-5.261l18.157-10.483a2.056,2.056,0,0,1,2.286-.122l2.534,1.88a2.056,2.056,0,0,0,2.286-.122l27.476-15.864c1.678-.968,3.038-.183,3.038,1.754Z",
    transform: "translate(-334.837 -62.078)",
    fill: "#ffdd57"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5579",
    "data-name": "Group 5579",
    transform: "translate(35.967 8.92)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5576",
    "data-name": "Group 5576"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10171",
    "data-name": "Path 10171",
    d: "M355.363,139.185l58.813-33.956V57.238c0-1.937-1.359-2.722-3.037-1.754l-10.7,6.18a6.349,6.349,0,0,0-2.285,2.517l-2.534,4.807a6.355,6.355,0,0,1-2.286,2.517L358.4,91.672a6.713,6.713,0,0,0-3.038,5.26Z",
    transform: "translate(-355.363 -55.07)",
    fill: "#ff5d73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10172",
    "data-name": "Path 10172",
    d: "M356.631,140.453,415.444,106.5V58.505c0-1.937-1.36-2.721-3.038-1.753l-10.7,6.179a6.342,6.342,0,0,0-2.286,2.518l-2.534,4.806a6.342,6.342,0,0,1-2.286,2.518L359.668,92.939a6.714,6.714,0,0,0-3.037,5.261Z",
    transform: "translate(-355.674 -55.381)",
    fill: "#ff7f8e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5577",
    "data-name": "Group 5577",
    transform: "translate(3.229 10.294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10173",
    "data-name": "Path 10173",
    d: "M412,115.806l-52.356,30.228v-47.1L412,68.71Z",
    transform: "translate(-359.641 -68.71)",
    fill: "#dce7f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10174",
    "data-name": "Path 10174",
    d: "M414.532,106.269,362.176,136.5V101.472l52.356-30.228Z",
    transform: "translate(-360.263 -69.332)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10175",
    "data-name": "Path 10175",
    d: "M413.91,70.623,412,68.71,359.641,98.938l1.913,1.913Z",
    transform: "translate(-359.641 -68.71)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5578",
    "data-name": "Group 5578",
    transform: "translate(7.652 13.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10176",
    "data-name": "Path 10176",
    d: "M424.315,105.163,365.5,139.118V103.2a6.713,6.713,0,0,1,3.038-5.26L386.7,87.454a2.056,2.056,0,0,1,2.286-.122l2.534,1.881a2.056,2.056,0,0,0,2.285-.122l27.476-15.863c1.678-.969,3.037-.183,3.037,1.753Z",
    transform: "translate(-365.502 -72.813)",
    fill: "#ff5d73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10177",
    "data-name": "Path 10177",
    d: "M425.583,106.43,366.77,140.385V104.466a6.714,6.714,0,0,1,3.037-5.261l18.157-10.483a2.058,2.058,0,0,1,2.286-.122l2.534,1.881a2.059,2.059,0,0,0,2.286-.122L422.546,74.5c1.678-.968,3.038-.183,3.038,1.753Z",
    transform: "translate(-365.813 -73.124)",
    fill: "#ff7f8e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5583",
    "data-name": "Group 5583",
    transform: "translate(52.957 19.402)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5580",
    "data-name": "Group 5580"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10178",
    "data-name": "Path 10178",
    d: "M377.875,141l58.813-33.956V71.128c0-1.937-1.36-2.722-3.037-1.754l-10.7,6.179a6.346,6.346,0,0,0-2.285,2.518l-2.534,4.806a6.353,6.353,0,0,1-2.286,2.518l-34.931,20.168a6.713,6.713,0,0,0-3.038,5.26Z",
    transform: "translate(-377.875 -68.959)",
    fill: "#9588ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10179",
    "data-name": "Path 10179",
    d: "M379.143,142.271l58.813-33.956V72.4c0-1.937-1.36-2.722-3.038-1.753l-10.7,6.179a6.344,6.344,0,0,0-2.286,2.517L419.4,84.144a6.34,6.34,0,0,1-2.286,2.517L382.18,106.829a6.714,6.714,0,0,0-3.037,5.261Z",
    transform: "translate(-378.186 -69.27)",
    fill: "#a299ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5581",
    "data-name": "Group 5581",
    transform: "translate(3.229 10.294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10180",
    "data-name": "Path 10180",
    d: "M434.509,117.624l-52.356,30.228V112.827L434.509,82.6Z",
    transform: "translate(-382.153 -82.6)",
    fill: "#dce7f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10181",
    "data-name": "Path 10181",
    d: "M439.329,120.92l-52.356,30.228V116.124L439.329,85.9Z",
    transform: "translate(-383.336 -83.408)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10182",
    "data-name": "Path 10182",
    d: "M438.147,85.088,434.509,82.6l-52.356,30.228,3.638,2.488Z",
    transform: "translate(-382.153 -82.6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5582",
    "data-name": "Group 5582",
    transform: "translate(7.652 13.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10183",
    "data-name": "Path 10183",
    d: "M446.827,119.052l-58.813,33.956v-35.92a6.713,6.713,0,0,1,3.038-5.26l18.157-10.484a2.056,2.056,0,0,1,2.286-.122l2.534,1.881a2.056,2.056,0,0,0,2.285-.122L443.79,87.117c1.678-.968,3.037-.183,3.037,1.754Z",
    transform: "translate(-388.014 -86.702)",
    fill: "#9588ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10184",
    "data-name": "Path 10184",
    d: "M448.1,120.32l-58.813,33.956v-35.92a6.714,6.714,0,0,1,3.037-5.26l18.157-10.483a2.058,2.058,0,0,1,2.286-.122l2.534,1.881a2.058,2.058,0,0,0,2.286-.122l27.476-15.863c1.678-.968,3.038-.183,3.038,1.753Z",
    transform: "translate(-388.325 -87.013)",
    fill: "#a299ff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10185",
    "data-name": "Path 10185",
    d: "M390.383,194.164l78.312-45.214V90.982L390.383,136.2Z",
    transform: "translate(-327.986 -54.959)",
    fill: "#7076a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10186",
    "data-name": "Path 10186",
    d: "M468.695,90.982h-3.451l-74.861,43.221V136.2Z",
    transform: "translate(-327.986 -54.959)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10187",
    "data-name": "Path 10187",
    d: "M370.1,139.183v-1.991l-58.947-34.033h-3.449Z",
    transform: "translate(-307.706 -57.946)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10188",
    "data-name": "Path 10188",
    d: "M338.286,136.329a2.536,2.536,0,0,0-.328,1.352v5.546a5.3,5.3,0,0,0,2.213,4.228l14.043,8.109a1.865,1.865,0,0,0,.734.254,1.281,1.281,0,0,1-1.884.321l-14.044-8.108a5.3,5.3,0,0,1-2.213-4.229v-5.545C336.808,136.97,337.426,136.237,338.286,136.329Z",
    transform: "translate(-314.845 -66.081)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10189",
    "data-name": "Path 10189",
    d: "M307.706,103.158v57.969l62.4,36.024V139.183Zm21.963,26.963c0-1.629.991-2.379,2.213-1.673l14.044,8.109a5.3,5.3,0,0,1,2.213,4.228v5.546c0,1.629-.991,2.378-2.213,1.672l-14.044-8.108a5.3,5.3,0,0,1-2.213-4.229Z",
    transform: "translate(-307.706 -57.946)",
    fill: "#636094"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5586",
    "data-name": "Group 5586",
    transform: "translate(18.291 83.943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10190",
    "data-name": "Path 10190",
    d: "M331.942,171.52,356.5,185.7V168.655l-24.555-14.177Z",
    transform: "translate(-331.942 -154.477)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5584",
    "data-name": "Group 5584",
    transform: "translate(3.068 5.601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10191",
    "data-name": "Path 10191",
    d: "M336.007,162.563l18.42,10.635v-.664L336.007,161.9Z",
    transform: "translate(-336.007 -161.899)",
    fill: "#8187b2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5585",
    "data-name": "Group 5585",
    transform: "translate(3.068 10.296)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10192",
    "data-name": "Path 10192",
    d: "M336.007,168.783l18.42,10.635v-.664l-18.42-10.635Z",
    transform: "translate(-336.007 -168.119)",
    fill: "#8187b2"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10193",
    "data-name": "Path 10193",
    d: "M426.979,155.98v19.5L458,157.573v-19.5Z",
    transform: "translate(-336.963 -66.511)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10194",
    "data-name": "Path 10194",
    d: "M434.747,169.984v.918l19.291-11.138v-.918Z",
    transform: "translate(-338.869 -71.606)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10195",
    "data-name": "Path 10195",
    d: "M434.747,162.83v.918l19.291-11.138v-.918Z",
    transform: "translate(-338.869 -69.851)",
    fill: "#8187b2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5594",
    "data-name": "Group 5594",
    transform: "translate(55.672 157.449)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5593",
    "data-name": "Group 5593"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10196",
    "data-name": "Path 10196",
    d: "M267.782,395.963l-69.445-40.094V251.875l69.445,40.094Z",
    transform: "translate(-180.205 -251.875)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10197",
    "data-name": "Path 10197",
    d: "M266.739,397.529,199.86,358.916V254.922l65.766,37.97Z",
    transform: "translate(-180.579 -252.623)",
    fill: "#cdd4ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10198",
    "data-name": "Path 10198",
    d: "M192.443,377.386l-18.131,10.468V350.061l18.131-10.468Z",
    transform: "translate(-174.312 -273.392)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10199",
    "data-name": "Path 10199",
    d: "M193.967,378.148l-18.131,10.468V350.823l18.131-10.468Z",
    transform: "translate(-174.686 -273.579)",
    fill: "#b7bbd1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5589",
    "data-name": "Group 5589",
    transform: "translate(21.816 10.898)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10200",
    "data-name": "Path 10200",
    d: "M203.219,359.775l54.762,31.617v-93.46l-54.762-31.617Z",
    transform: "translate(-203.219 -266.315)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10201",
    "data-name": "Path 10201",
    d: "M212.378,335.065,253.7,358.922v-16.67l-41.321-23.857Z",
    transform: "translate(-205.466 -279.09)",
    fill: "#a0aed3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10202",
    "data-name": "Path 10202",
    d: "M212.378,370.517,253.7,394.374v-23.6l-41.321-23.856Z",
    transform: "translate(-205.466 -286.087)",
    fill: "#a0aed3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10203",
    "data-name": "Path 10203",
    d: "M230.8,305.324l-18.42-10.635V290.5l18.42,10.635Z",
    transform: "translate(-205.466 -272.247)",
    fill: "#a0aed3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5590",
    "data-name": "Group 5590",
    transform: "translate(18.389 13.438)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10204",
    "data-name": "Path 10204",
    d: "M198.678,363.141l54.762,31.617V301.3l-54.762-31.617Z",
    transform: "translate(-198.678 -269.681)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10205",
    "data-name": "Path 10205",
    d: "M207.837,338.431l41.321,23.857v-16.67L207.837,321.76Z",
    transform: "translate(-200.925 -282.456)",
    fill: "#a0aed3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10206",
    "data-name": "Path 10206",
    d: "M207.837,373.883l41.321,23.857v-23.6l-41.321-23.857Z",
    transform: "translate(-200.925 -289.453)",
    fill: "#a0aed3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10207",
    "data-name": "Path 10207",
    d: "M226.257,308.689l-18.42-10.635v-4.193l18.42,10.635Z",
    transform: "translate(-200.925 -275.612)",
    fill: "#a0aed3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5591",
    "data-name": "Group 5591",
    transform: "translate(15.829 15.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10208",
    "data-name": "Path 10208",
    d: "M195.285,366.534l54.762,31.617v-93.46l-54.762-31.617Z",
    transform: "translate(-195.285 -273.074)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10209",
    "data-name": "Path 10209",
    d: "M204.444,341.824l41.321,23.856V349.01l-41.321-23.857Z",
    transform: "translate(-197.532 -285.849)",
    fill: "#a0aed3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10210",
    "data-name": "Path 10210",
    d: "M204.444,377.276l41.321,23.857v-23.6l-41.321-23.857Z",
    transform: "translate(-197.532 -292.846)",
    fill: "#a0aed3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10211",
    "data-name": "Path 10211",
    d: "M222.864,312.082l-18.42-10.635v-4.193l18.42,10.635Z",
    transform: "translate(-197.532 -279.005)",
    fill: "#a0aed3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5592",
    "data-name": "Group 5592",
    transform: "translate(12.606 18.037)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10212",
    "data-name": "Path 10212",
    d: "M191.015,369.234l54.762,31.617v-93.46l-54.762-31.617Z",
    transform: "translate(-191.015 -275.775)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10213",
    "data-name": "Path 10213",
    d: "M200.175,336.907,241.5,360.764v-16.67l-41.321-23.857Z",
    transform: "translate(-193.262 -286.681)",
    fill: "#ff7f8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10214",
    "data-name": "Path 10214",
    d: "M200.175,375.823,241.5,399.68V370.333l-41.321-23.857Z",
    transform: "translate(-193.262 -293.118)",
    fill: "#ffdd57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10215",
    "data-name": "Path 10215",
    d: "M218.595,313.405l-18.42-10.635v-2.815l18.42,10.635Z",
    transform: "translate(-193.262 -281.706)",
    fill: "#a299ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10216",
    "data-name": "Path 10216",
    d: "M245.281,419.562l-69.445-40.005V341.764c40.267,23.249,41.927-41.995,57.941-32.749l11.5,6.642Z",
    transform: "translate(-174.686 -265.67)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10217",
    "data-name": "Path 10217",
    d: "M243.757,420.412l-69.445-40.094V342.526c40.268,23.248,41.927-41.995,57.941-32.75l11.5,6.642Z",
    transform: "translate(-174.312 -265.856)",
    fill: "#636094"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10218",
    "data-name": "Path 10218",
    d: "M264.806,314.646l1.15.621L284.086,304.8l-1.15-.621Z",
    transform: "translate(-196.51 -264.705)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2345",
    "data-name": "Rectangle 2345",
    width: 2.056,
    height: 21.916,
    transform: "translate(76.579 116.001)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2346",
    "data-name": "Rectangle 2346",
    width: 2.415,
    height: 21.916,
    transform: "translate(78.634 116.001)",
    fill: "#e3e7ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10219",
    "data-name": "Path 10219",
    d: "M266.329,315.469V419.463L284.46,409V305Zm9.065,83.549c-3.37,1.946-6.1.369-6.1-3.523a13.489,13.489,0,0,1,6.1-10.57c3.371-1.946,6.1-.368,6.1,3.524A13.488,13.488,0,0,1,275.394,399.018Z",
    transform: "translate(-196.884 -264.907)",
    fill: "#7076a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10220",
    "data-name": "Path 10220",
    d: "M281.268,410.609a5.1,5.1,0,0,1,.915,3.17,13.49,13.49,0,0,1-6.1,10.57c-1.844,1.065-3.493,1.068-4.613.221,1.075,1.386,2.994,1.62,5.188.353a13.488,13.488,0,0,0,6.1-10.57A4.5,4.5,0,0,0,281.268,410.609Z",
    transform: "translate(-198.144 -290.812)",
    fill: "#8187b2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10221",
    "data-name": "Path 10221",
    d: "M231.365,407.425v12.154L187.757,394.3V382.145Z",
    transform: "translate(-177.61 -283.83)",
    fill: "#f7f7f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5600",
    "data-name": "Group 5600",
    transform: "translate(32.186 170.93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5599",
    "data-name": "Group 5599"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10222",
    "data-name": "Path 10222",
    d: "M236.661,413.826l-69.445-40.094V269.737l69.445,40.094Z",
    transform: "translate(-149.085 -269.737)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10223",
    "data-name": "Path 10223",
    d: "M235.618,415.391l-66.879-38.613V272.784l65.766,37.97Z",
    transform: "translate(-149.458 -270.485)",
    fill: "#cdd4ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10224",
    "data-name": "Path 10224",
    d: "M161.323,395.249l-18.131,10.468V367.924l18.131-10.468Z",
    transform: "translate(-143.192 -291.255)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10225",
    "data-name": "Path 10225",
    d: "M162.846,396.01l-18.131,10.468V368.685l18.131-10.468Z",
    transform: "translate(-143.565 -291.441)",
    fill: "#b7bbd1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5595",
    "data-name": "Group 5595",
    transform: "translate(21.816 10.898)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10226",
    "data-name": "Path 10226",
    d: "M172.1,377.637l54.762,31.617v-93.46L172.1,284.178Z",
    transform: "translate(-172.098 -284.178)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10227",
    "data-name": "Path 10227",
    d: "M181.257,352.927l41.321,23.857v-16.67l-41.321-23.857Z",
    transform: "translate(-174.345 -296.953)",
    fill: "#a0aed3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10228",
    "data-name": "Path 10228",
    d: "M181.257,388.38l41.321,23.857v-23.6l-41.321-23.857Z",
    transform: "translate(-174.345 -303.95)",
    fill: "#a0aed3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10229",
    "data-name": "Path 10229",
    d: "M199.678,323.186l-18.42-10.635v-4.193l18.42,10.635Z",
    transform: "translate(-174.345 -290.109)",
    fill: "#a0aed3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5596",
    "data-name": "Group 5596",
    transform: "translate(18.389 13.438)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10230",
    "data-name": "Path 10230",
    d: "M167.557,381,222.32,412.62V319.16l-54.762-31.617Z",
    transform: "translate(-167.557 -287.543)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10231",
    "data-name": "Path 10231",
    d: "M176.717,356.293l41.321,23.857v-16.67l-41.321-23.857Z",
    transform: "translate(-169.804 -300.318)",
    fill: "#a0aed3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10232",
    "data-name": "Path 10232",
    d: "M176.717,391.745,218.037,415.6V392l-41.321-23.857Z",
    transform: "translate(-169.804 -307.315)",
    fill: "#a0aed3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10233",
    "data-name": "Path 10233",
    d: "M195.137,326.552l-18.42-10.635v-4.193l18.42,10.635Z",
    transform: "translate(-169.804 -293.475)",
    fill: "#a0aed3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5597",
    "data-name": "Group 5597",
    transform: "translate(15.828 15.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10234",
    "data-name": "Path 10234",
    d: "M164.164,384.4l54.762,31.617v-93.46l-54.762-31.617Z",
    transform: "translate(-164.164 -290.936)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10235",
    "data-name": "Path 10235",
    d: "M173.324,359.686l41.321,23.857v-16.67l-41.321-23.857Z",
    transform: "translate(-166.411 -303.711)",
    fill: "#a0aed3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10236",
    "data-name": "Path 10236",
    d: "M173.324,395.138l41.321,23.857V395.4L173.324,371.54Z",
    transform: "translate(-166.411 -310.708)",
    fill: "#a0aed3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10237",
    "data-name": "Path 10237",
    d: "M191.744,329.944l-18.42-10.635v-4.193l18.42,10.635Z",
    transform: "translate(-166.411 -296.868)",
    fill: "#a0aed3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5598",
    "data-name": "Group 5598",
    transform: "translate(12.606 18.037)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10238",
    "data-name": "Path 10238",
    d: "M159.895,387.1l54.762,31.617v-93.46l-54.762-31.617Z",
    transform: "translate(-159.895 -293.637)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10239",
    "data-name": "Path 10239",
    d: "M169.054,354.77l41.321,23.857v-16.67L169.054,338.1Z",
    transform: "translate(-162.142 -304.543)",
    fill: "#ff7f8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10240",
    "data-name": "Path 10240",
    d: "M169.054,393.685l41.321,23.857V388.2l-41.321-23.856Z",
    transform: "translate(-162.142 -310.98)",
    fill: "#ffdd57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10241",
    "data-name": "Path 10241",
    d: "M187.474,331.268l-18.42-10.635v-2.815l18.42,10.635Z",
    transform: "translate(-162.142 -299.568)",
    fill: "#f7f7f9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10242",
    "data-name": "Path 10242",
    d: "M214.16,437.424l-69.445-40.005V359.626c40.267,23.249,41.927-41.995,57.941-32.749l11.5,6.642Z",
    transform: "translate(-143.565 -283.532)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10243",
    "data-name": "Path 10243",
    d: "M212.637,438.275l-69.445-40.094V360.388c40.267,23.248,41.927-41.995,57.94-32.749l11.5,6.642Z",
    transform: "translate(-143.192 -283.719)",
    fill: "#636094"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10244",
    "data-name": "Path 10244",
    d: "M233.685,332.508l1.15.621,18.131-10.468-1.15-.621Z",
    transform: "translate(-165.389 -282.567)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2347",
    "data-name": "Rectangle 2347",
    width: 2.056,
    height: 21.916,
    transform: "translate(76.578 116.001)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2348",
    "data-name": "Rectangle 2348",
    width: 2.415,
    height: 21.916,
    transform: "translate(78.634 116.001)",
    fill: "#e3e7ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10245",
    "data-name": "Path 10245",
    d: "M235.208,333.331V437.325l18.131-10.468V322.863Zm9.065,83.549c-3.37,1.946-6.1.368-6.1-3.524a13.487,13.487,0,0,1,6.1-10.57c3.371-1.946,6.1-.369,6.1,3.523A13.49,13.49,0,0,1,244.273,416.881Z",
    transform: "translate(-165.763 -282.769)",
    fill: "#7076a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10246",
    "data-name": "Path 10246",
    d: "M250.147,428.472a5.1,5.1,0,0,1,.915,3.169,13.489,13.489,0,0,1-6.1,10.57c-1.844,1.065-3.494,1.069-4.614.221,1.075,1.386,2.994,1.62,5.188.354a13.49,13.49,0,0,0,6.1-10.57A4.5,4.5,0,0,0,250.147,428.472Z",
    transform: "translate(-167.023 -308.675)",
    fill: "#8187b2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10247",
    "data-name": "Path 10247",
    d: "M200.245,425.287v12.154l-43.608-25.28V400.007Z",
    transform: "translate(-146.49 -301.692)",
    fill: "#f7f7f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5606",
    "data-name": "Group 5606",
    transform: "translate(0 190.458)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5605",
    "data-name": "Group 5605"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10248",
    "data-name": "Path 10248",
    d: "M194.014,439.7l-69.445-40.094V295.612l69.445,40.094Z",
    transform: "translate(-106.438 -295.612)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10249",
    "data-name": "Path 10249",
    d: "M192.971,441.266l-66.879-38.613V298.659l65.766,37.97Z",
    transform: "translate(-106.812 -296.36)",
    fill: "#cdd4ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10250",
    "data-name": "Path 10250",
    d: "M118.676,421.123l-18.131,10.468V393.8l18.131-10.468Z",
    transform: "translate(-100.545 -317.129)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10251",
    "data-name": "Path 10251",
    d: "M120.2,421.885l-18.131,10.468V394.56L120.2,384.092Z",
    transform: "translate(-100.919 -317.316)",
    fill: "#b7bbd1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5601",
    "data-name": "Group 5601",
    transform: "translate(21.816 10.898)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10252",
    "data-name": "Path 10252",
    d: "M129.452,403.512l54.762,31.617v-93.46l-54.762-31.617Z",
    transform: "translate(-129.452 -310.052)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10253",
    "data-name": "Path 10253",
    d: "M138.611,378.8l41.321,23.857v-16.67l-41.321-23.857Z",
    transform: "translate(-131.698 -322.827)",
    fill: "#a0aed3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10254",
    "data-name": "Path 10254",
    d: "M138.611,414.254l41.321,23.857v-23.6l-41.321-23.857Z",
    transform: "translate(-131.698 -329.824)",
    fill: "#a0aed3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10255",
    "data-name": "Path 10255",
    d: "M157.031,349.061l-18.42-10.635v-4.193l18.42,10.635Z",
    transform: "translate(-131.698 -315.984)",
    fill: "#a0aed3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5602",
    "data-name": "Group 5602",
    transform: "translate(18.389 13.438)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10256",
    "data-name": "Path 10256",
    d: "M124.911,406.878l54.762,31.617v-93.46l-54.762-31.617Z",
    transform: "translate(-124.911 -313.418)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10257",
    "data-name": "Path 10257",
    d: "M134.07,382.168l41.321,23.857v-16.67L134.07,365.5Z",
    transform: "translate(-127.158 -326.193)",
    fill: "#a0aed3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10258",
    "data-name": "Path 10258",
    d: "M134.07,417.62l41.321,23.857v-23.6L134.07,394.022Z",
    transform: "translate(-127.158 -333.19)",
    fill: "#a0aed3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10259",
    "data-name": "Path 10259",
    d: "M152.49,352.426l-18.42-10.635V337.6l18.42,10.635Z",
    transform: "translate(-127.158 -319.35)",
    fill: "#a0aed3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5603",
    "data-name": "Group 5603",
    transform: "translate(15.828 15.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10260",
    "data-name": "Path 10260",
    d: "M121.518,410.271l54.762,31.617v-93.46l-54.762-31.617Z",
    transform: "translate(-121.518 -316.811)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10261",
    "data-name": "Path 10261",
    d: "M130.677,385.561,172,409.417v-16.67L130.677,368.89Z",
    transform: "translate(-123.765 -329.586)",
    fill: "#a0aed3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10262",
    "data-name": "Path 10262",
    d: "M130.677,421.013,172,444.869v-23.6l-41.321-23.857Z",
    transform: "translate(-123.765 -336.583)",
    fill: "#a0aed3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10263",
    "data-name": "Path 10263",
    d: "M149.1,355.819l-18.42-10.635v-4.193l18.42,10.635Z",
    transform: "translate(-123.765 -322.742)",
    fill: "#a0aed3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5604",
    "data-name": "Group 5604",
    transform: "translate(12.606 18.037)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10264",
    "data-name": "Path 10264",
    d: "M117.248,412.971l54.762,31.617v-93.46l-54.762-31.617Z",
    transform: "translate(-117.248 -319.512)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10265",
    "data-name": "Path 10265",
    d: "M126.407,380.644,167.728,404.5v-16.67l-41.321-23.857Z",
    transform: "translate(-119.495 -330.418)",
    fill: "#ff7f8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10266",
    "data-name": "Path 10266",
    d: "M126.407,419.56l41.321,23.857V414.07l-41.321-23.857Z",
    transform: "translate(-119.495 -336.855)",
    fill: "#ffdd57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10267",
    "data-name": "Path 10267",
    d: "M144.827,357.142l-18.42-10.635v-2.815l18.42,10.635Z",
    transform: "translate(-119.495 -325.443)",
    fill: "#a299ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10268",
    "data-name": "Path 10268",
    d: "M171.513,463.3l-69.445-40.005V385.5c40.268,23.249,41.927-41.995,57.941-32.749l11.5,6.642Z",
    transform: "translate(-100.919 -309.407)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10269",
    "data-name": "Path 10269",
    d: "M169.99,464.149l-69.445-40.094V386.263c40.267,23.248,41.927-41.995,57.941-32.75l11.5,6.642Z",
    transform: "translate(-100.545 -309.593)",
    fill: "#636094"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10270",
    "data-name": "Path 10270",
    d: "M191.038,358.383l1.15.621,18.131-10.468-1.15-.621Z",
    transform: "translate(-122.743 -308.442)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2349",
    "data-name": "Rectangle 2349",
    width: 2.056,
    height: 21.916,
    transform: "translate(76.578 116.001)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2350",
    "data-name": "Rectangle 2350",
    width: 2.415,
    height: 21.916,
    transform: "translate(78.634 116.001)",
    fill: "#e3e7ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10271",
    "data-name": "Path 10271",
    d: "M192.562,359.206V463.2l18.131-10.468V348.738Zm9.065,83.549c-3.37,1.946-6.1.369-6.1-3.523a13.49,13.49,0,0,1,6.1-10.57c3.37-1.946,6.1-.368,6.1,3.524A13.488,13.488,0,0,1,201.627,442.755Z",
    transform: "translate(-123.117 -308.644)",
    fill: "#7076a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10272",
    "data-name": "Path 10272",
    d: "M207.5,454.346a5.1,5.1,0,0,1,.915,3.17,13.489,13.489,0,0,1-6.1,10.57c-1.844,1.065-3.494,1.068-4.613.221,1.075,1.386,2.993,1.62,5.188.353a13.488,13.488,0,0,0,6.1-10.57A4.5,4.5,0,0,0,207.5,454.346Z",
    transform: "translate(-124.377 -334.549)",
    fill: "#8187b2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10273",
    "data-name": "Path 10273",
    d: "M157.6,451.162v12.154l-43.608-25.281V425.882Z",
    transform: "translate(-103.843 -327.567)",
    fill: "#f7f7f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5623",
    "data-name": "Group 5623",
    transform: "translate(126.855 248.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5622",
    "data-name": "Group 5622"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10274",
    "data-name": "Path 10274",
    d: "M346.944,530.345l-78.31-45.212,62.4-36.024,78.31,45.212Z",
    transform: "translate(-268.632 -391.14)",
    fill: "#636094"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10275",
    "data-name": "Path 10275",
    d: "M331.031,372.3v57.968l-62.4,36.024V408.324Z",
    transform: "translate(-268.632 -372.299)",
    fill: "#b7bbd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10276",
    "data-name": "Path 10276",
    d: "M351.311,430.267l65.721,37.944,12.589-50.7L351.311,372.3Z",
    transform: "translate(-288.913 -372.299)",
    fill: "#e6edf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10277",
    "data-name": "Path 10277",
    d: "M331.031,372.3l-62.4,36.024,78.309,45.213,62.4-36.024Zm-58.947,36.024,58.947-34.033,74.86,43.221-58.947,34.033Z",
    transform: "translate(-268.632 -372.299)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5610",
    "data-name": "Group 5610",
    transform: "translate(60.697 0.584)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5607",
    "data-name": "Group 5607",
    transform: "translate(7.652)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10278",
    "data-name": "Path 10278",
    d: "M419.277,445.116,360.464,411.16V375.24c0-1.937,1.359-2.721,3.037-1.753l10.7,6.179a6.346,6.346,0,0,1,2.285,2.518l2.534,4.806a6.353,6.353,0,0,0,2.286,2.518l34.931,20.167a6.713,6.713,0,0,1,3.038,5.261Z",
    transform: "translate(-359.507 -373.072)",
    fill: "#ffb236"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10279",
    "data-name": "Path 10279",
    d: "M418.009,446.384,359.2,412.427V376.508c0-1.937,1.36-2.722,3.038-1.754l10.7,6.179a6.342,6.342,0,0,1,2.286,2.518l2.534,4.806a6.342,6.342,0,0,0,2.286,2.518l34.931,20.168a6.714,6.714,0,0,1,3.037,5.26Z",
    transform: "translate(-359.196 -373.383)",
    fill: "#ffdd57"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5608",
    "data-name": "Group 5608",
    transform: "translate(9.074 11.057)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10280",
    "data-name": "Path 10280",
    d: "M363.615,422.748l52.356,30.228V417.951l-52.356-30.228Z",
    transform: "translate(-361.702 -387.724)",
    fill: "#dce7f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10281",
    "data-name": "Path 10281",
    d: "M361.08,425.283l52.356,30.228V420.486L361.08,390.259Z",
    transform: "translate(-361.08 -388.345)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10282",
    "data-name": "Path 10282",
    d: "M361.08,389.637l1.913-1.913,52.356,30.228-1.913,1.913Z",
    transform: "translate(-361.08 -387.724)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5609",
    "data-name": "Group 5609",
    transform: "translate(0 13.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10283",
    "data-name": "Path 10283",
    d: "M350.325,423.165l58.813,33.956V421.2a6.713,6.713,0,0,0-3.038-5.261l-18.157-10.483a2.058,2.058,0,0,0-2.286-.122l-2.534,1.881a2.056,2.056,0,0,1-2.285-.121L353.362,391.23c-1.678-.968-3.037-.183-3.037,1.754Z",
    transform: "translate(-349.368 -390.815)",
    fill: "#ffb236"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10284",
    "data-name": "Path 10284",
    d: "M349.057,444.552l58.813,33.956v-56.04a6.714,6.714,0,0,0-3.037-5.26l-18.157-10.484a2.056,2.056,0,0,0-2.286-.122l-2.534,1.881a2.058,2.058,0,0,1-2.286-.122L352.095,392.5c-1.678-.968-3.038-.183-3.038,1.754Z",
    transform: "translate(-349.057 -391.126)",
    fill: "#ffdd57"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5614",
    "data-name": "Group 5614",
    transform: "translate(37.32 8.92)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5611",
    "data-name": "Group 5611",
    transform: "translate(7.652)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10285",
    "data-name": "Path 10285",
    d: "M388.3,468.234l-58.814-33.956V386.286c0-1.937,1.36-2.722,3.038-1.753l10.7,6.179a6.345,6.345,0,0,1,2.286,2.517l2.534,4.807a6.351,6.351,0,0,0,2.286,2.517l34.931,20.168a6.712,6.712,0,0,1,3.037,5.26Z",
    transform: "translate(-328.531 -384.118)",
    fill: "#9588ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10286",
    "data-name": "Path 10286",
    d: "M387.033,469.5,328.22,435.546V387.553c0-1.937,1.36-2.721,3.038-1.753l10.7,6.179a6.342,6.342,0,0,1,2.286,2.518l2.534,4.806a6.342,6.342,0,0,0,2.286,2.518L384,421.987a6.715,6.715,0,0,1,3.037,5.261Z",
    transform: "translate(-328.22 -384.429)",
    fill: "#a299ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5612",
    "data-name": "Group 5612",
    transform: "translate(9.924 10.294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10287",
    "data-name": "Path 10287",
    d: "M333.766,444.854l52.356,30.228v-47.1l-52.356-30.228Z",
    transform: "translate(-331.853 -397.758)",
    fill: "#dce7f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10288",
    "data-name": "Path 10288",
    d: "M331.231,435.317l52.356,30.228V430.521l-52.356-30.228Z",
    transform: "translate(-331.231 -398.38)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10289",
    "data-name": "Path 10289",
    d: "M331.231,399.671l1.913-1.913L385.5,427.986l-1.913,1.913Z",
    transform: "translate(-331.231 -397.758)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5613",
    "data-name": "Group 5613",
    transform: "translate(0 13.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10290",
    "data-name": "Path 10290",
    d: "M319.348,434.211l58.813,33.956v-35.92a6.712,6.712,0,0,0-3.037-5.26L356.967,416.5a2.058,2.058,0,0,0-2.286-.122l-2.534,1.881a2.058,2.058,0,0,1-2.286-.122l-27.476-15.863c-1.678-.968-3.038-.183-3.038,1.753Z",
    transform: "translate(-318.392 -401.861)",
    fill: "#9588ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10291",
    "data-name": "Path 10291",
    d: "M318.081,435.478l58.813,33.956V433.514a6.714,6.714,0,0,0-3.038-5.261L355.7,417.77a2.058,2.058,0,0,0-2.286-.122l-2.534,1.881a2.057,2.057,0,0,1-2.286-.121l-27.476-15.864c-1.677-.968-3.037-.183-3.037,1.754Z",
    transform: "translate(-318.081 -402.172)",
    fill: "#a299ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5618",
    "data-name": "Group 5618",
    transform: "translate(20.33 19.402)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5615",
    "data-name": "Group 5615",
    transform: "translate(7.652)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10292",
    "data-name": "Path 10292",
    d: "M365.789,470.052,306.976,436.1V400.176c0-1.937,1.359-2.722,3.037-1.754l10.7,6.18A6.343,6.343,0,0,1,323,407.119l2.534,4.807a6.355,6.355,0,0,0,2.286,2.517l34.931,20.168a6.713,6.713,0,0,1,3.038,5.26Z",
    transform: "translate(-306.019 -398.007)",
    fill: "#ffb236"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10293",
    "data-name": "Path 10293",
    d: "M364.521,471.319l-58.813-33.956v-35.92c0-1.937,1.36-2.722,3.038-1.753l10.7,6.179a6.345,6.345,0,0,1,2.286,2.517l2.534,4.807a6.339,6.339,0,0,0,2.286,2.517l34.931,20.168a6.714,6.714,0,0,1,3.037,5.261Z",
    transform: "translate(-305.708 -398.318)",
    fill: "#ffdd57"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5616",
    "data-name": "Group 5616",
    transform: "translate(8.2 10.294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10294",
    "data-name": "Path 10294",
    d: "M311.254,446.672,363.61,476.9V441.875l-52.356-30.228Z",
    transform: "translate(-307.616 -411.648)",
    fill: "#dce7f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10295",
    "data-name": "Path 10295",
    d: "M306.434,449.969,358.79,480.2V445.172l-52.356-30.228Z",
    transform: "translate(-306.434 -412.456)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10296",
    "data-name": "Path 10296",
    d: "M306.434,414.136l3.638-2.488,52.356,30.228-3.638,2.488Z",
    transform: "translate(-306.434 -411.648)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5617",
    "data-name": "Group 5617",
    transform: "translate(0 13.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10297",
    "data-name": "Path 10297",
    d: "M296.836,448.1l58.813,33.956v-35.92a6.712,6.712,0,0,0-3.037-5.26l-18.157-10.484a2.056,2.056,0,0,0-2.286-.122l-2.534,1.881a2.056,2.056,0,0,1-2.285-.122l-27.476-15.863c-1.678-.969-3.038-.183-3.038,1.753Z",
    transform: "translate(-295.88 -415.751)",
    fill: "#ffb236"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10298",
    "data-name": "Path 10298",
    d: "M295.569,449.368l58.813,33.956V447.4a6.714,6.714,0,0,0-3.037-5.261L333.188,431.66a2.058,2.058,0,0,0-2.286-.122l-2.534,1.881a2.058,2.058,0,0,1-2.286-.122l-27.476-15.863c-1.678-.968-3.038-.183-3.038,1.753Z",
    transform: "translate(-295.569 -416.062)",
    fill: "#ffdd57"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10299",
    "data-name": "Path 10299",
    d: "M346.944,523.212,268.632,478V420.031l78.312,45.214Z",
    transform: "translate(-268.632 -384.007)",
    fill: "#636094"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10300",
    "data-name": "Path 10300",
    d: "M268.632,420.031h3.451l74.861,43.221v1.991Z",
    transform: "translate(-268.632 -384.007)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10301",
    "data-name": "Path 10301",
    d: "M372.4,468.231V466.24l58.947-34.033h3.449Z",
    transform: "translate(-294.085 -386.994)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10302",
    "data-name": "Path 10302",
    d: "M418.6,465.377a2.536,2.536,0,0,1,.328,1.352v5.546a5.3,5.3,0,0,1-2.213,4.228l-14.043,8.109a1.865,1.865,0,0,1-.734.254,1.281,1.281,0,0,0,1.884.321l14.044-8.108a5.3,5.3,0,0,0,2.213-4.229V467.3C420.076,466.018,419.458,465.285,418.6,465.377Z",
    transform: "translate(-301.331 -395.129)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10303",
    "data-name": "Path 10303",
    d: "M372.4,468.231V526.2l62.4-36.024V432.207Zm40.433-3.517a5.3,5.3,0,0,1-2.213,4.229l-14.044,8.108c-1.222.706-2.213-.043-2.213-1.672v-5.546a5.3,5.3,0,0,1,2.213-4.228l14.044-8.109c1.222-.706,2.213.044,2.213,1.673Z",
    transform: "translate(-294.085 -386.994)",
    fill: "#7076a5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5621",
    "data-name": "Group 5621",
    transform: "translate(97.862 83.943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10304",
    "data-name": "Path 10304",
    d: "M422.857,500.568,398.3,514.745V497.7l24.555-14.177Z",
    transform: "translate(-398.301 -483.526)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5619",
    "data-name": "Group 5619",
    transform: "translate(3.068 5.601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10305",
    "data-name": "Path 10305",
    d: "M420.786,491.611l-18.42,10.635v-.664l18.42-10.635Z",
    transform: "translate(-402.366 -490.947)",
    fill: "#8187b2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5620",
    "data-name": "Group 5620",
    transform: "translate(3.068 10.296)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10306",
    "data-name": "Path 10306",
    d: "M420.786,497.831l-18.42,10.635V507.8l18.42-10.635Z",
    transform: "translate(-402.366 -497.167)",
    fill: "#8187b2"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10307",
    "data-name": "Path 10307",
    d: "M325.72,485.029v19.5L294.7,486.622v-19.5Z",
    transform: "translate(-275.027 -395.559)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10308",
    "data-name": "Path 10308",
    d: "M321.763,499.033v.918l-19.291-11.138v-.918Z",
    transform: "translate(-276.933 -400.654)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10309",
    "data-name": "Path 10309",
    d: "M321.763,491.878v.918l-19.291-11.138v-.918Z",
    transform: "translate(-276.933 -398.899)",
    fill: "#8187b2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5636",
    "data-name": "Group 5636",
    transform: "translate(302.55 222.264)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5635",
    "data-name": "Group 5635",
    transform: "translate(1.513 5.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10310",
    "data-name": "Path 10310",
    d: "M565.834,502.817l78.31-45.212-62.4-36.024-78.31,45.212Z",
    transform: "translate(-503.438 -363.612)",
    fill: "#636094"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10311",
    "data-name": "Path 10311",
    d: "M607.2,344.771v57.968l62.4,36.024V380.8Z",
    transform: "translate(-528.89 -344.771)",
    fill: "#b7bbd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10312",
    "data-name": "Path 10312",
    d: "M581.747,402.739l-65.721,37.944-12.589-50.7,78.31-45.212Z",
    transform: "translate(-503.438 -344.771)",
    fill: "#e6edf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10313",
    "data-name": "Path 10313",
    d: "M503.438,389.983l62.4,36.024,78.31-45.212-62.4-36.024Zm62.4,34.033-58.947-34.033,74.86-43.221L640.694,380.8Z",
    transform: "translate(-503.438 -344.771)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5627",
    "data-name": "Group 5627",
    transform: "translate(12.589 7.376)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5624",
    "data-name": "Group 5624"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10314",
    "data-name": "Path 10314",
    d: "M520.118,426.588l58.813-33.956v-35.92c0-1.937-1.359-2.722-3.037-1.753l-10.7,6.179a6.348,6.348,0,0,0-2.285,2.517l-2.534,4.807a6.355,6.355,0,0,1-2.286,2.517l-34.931,20.168a6.713,6.713,0,0,0-3.038,5.26Z",
    transform: "translate(-520.118 -354.544)",
    fill: "#ffb236"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10315",
    "data-name": "Path 10315",
    d: "M521.386,427.855,580.2,393.9v-35.92c0-1.937-1.36-2.721-3.038-1.753l-10.7,6.179a6.341,6.341,0,0,0-2.286,2.518l-2.534,4.806a6.341,6.341,0,0,1-2.286,2.518l-34.931,20.167a6.715,6.715,0,0,0-3.037,5.261Z",
    transform: "translate(-520.429 -354.855)",
    fill: "#ffdd57"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5625",
    "data-name": "Group 5625",
    transform: "translate(4.079 11.057)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10316",
    "data-name": "Path 10316",
    d: "M577.879,404.22l-52.356,30.228V399.423L577.879,369.2Z",
    transform: "translate(-525.523 -369.195)",
    fill: "#dce7f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10317",
    "data-name": "Path 10317",
    d: "M580.414,406.754l-52.356,30.228V401.958l52.356-30.228Z",
    transform: "translate(-526.145 -369.817)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10318",
    "data-name": "Path 10318",
    d: "M579.792,371.108l-1.913-1.913-52.356,30.228,1.913,1.913Z",
    transform: "translate(-525.523 -369.195)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5626",
    "data-name": "Group 5626",
    transform: "translate(7.653 13.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10319",
    "data-name": "Path 10319",
    d: "M589.071,404.637l-58.813,33.956v-35.92a6.712,6.712,0,0,1,3.037-5.26l18.157-10.483a2.056,2.056,0,0,1,2.286-.122l2.534,1.881a2.056,2.056,0,0,0,2.285-.122L586.033,372.7c1.678-.968,3.038-.183,3.038,1.753Z",
    transform: "translate(-530.258 -372.287)",
    fill: "#ffb236"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10320",
    "data-name": "Path 10320",
    d: "M590.338,426.023,531.525,459.98V403.94a6.715,6.715,0,0,1,3.037-5.261L552.719,388.2a2.058,2.058,0,0,1,2.286-.122l2.534,1.881a2.056,2.056,0,0,0,2.286-.122L587.3,373.969c1.678-.968,3.038-.183,3.038,1.753Z",
    transform: "translate(-530.569 -372.598)",
    fill: "#ff7f8e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5631",
    "data-name": "Group 5631",
    transform: "translate(35.967 15.712)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5628",
    "data-name": "Group 5628"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10321",
    "data-name": "Path 10321",
    d: "M551.095,449.705l58.813-33.956V367.758c0-1.937-1.36-2.722-3.038-1.754l-10.7,6.179a6.342,6.342,0,0,0-2.286,2.518l-2.534,4.806a6.341,6.341,0,0,1-2.286,2.518l-34.931,20.168a6.712,6.712,0,0,0-3.037,5.26Z",
    transform: "translate(-551.095 -365.589)",
    fill: "#ffb236"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10322",
    "data-name": "Path 10322",
    d: "M552.362,450.973l58.813-33.956V369.025c0-1.937-1.36-2.722-3.038-1.753l-10.7,6.179a6.346,6.346,0,0,0-2.286,2.517l-2.533,4.807a6.345,6.345,0,0,1-2.286,2.517L555.4,403.459a6.714,6.714,0,0,0-3.037,5.26Z",
    transform: "translate(-551.406 -365.9)",
    fill: "#ffdd57"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5629",
    "data-name": "Group 5629",
    transform: "translate(3.228 10.294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10323",
    "data-name": "Path 10323",
    d: "M607.729,426.326l-52.356,30.228v-47.1l52.356-30.228Z",
    transform: "translate(-555.373 -379.23)",
    fill: "#dce7f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10324",
    "data-name": "Path 10324",
    d: "M610.263,416.789l-52.356,30.228V411.992l52.356-30.228Z",
    transform: "translate(-555.994 -379.851)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10325",
    "data-name": "Path 10325",
    d: "M609.642,381.143l-1.913-1.913-52.356,30.228,1.913,1.913Z",
    transform: "translate(-555.373 -379.23)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5630",
    "data-name": "Group 5630",
    transform: "translate(7.652 13.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10326",
    "data-name": "Path 10326",
    d: "M620.047,415.682l-58.813,33.956v-35.92a6.714,6.714,0,0,1,3.037-5.26l18.157-10.484a2.056,2.056,0,0,1,2.286-.122l2.534,1.881a2.058,2.058,0,0,0,2.286-.122l27.476-15.864c1.678-.968,3.038-.183,3.038,1.754Z",
    transform: "translate(-561.234 -383.332)",
    fill: "#ff5d73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10327",
    "data-name": "Path 10327",
    d: "M621.314,416.95,562.5,450.905v-35.92a6.713,6.713,0,0,1,3.038-5.26L583.7,399.242a2.058,2.058,0,0,1,2.286-.122L588.515,401a2.058,2.058,0,0,0,2.286-.122l27.476-15.863c1.677-.968,3.037-.183,3.037,1.753Z",
    transform: "translate(-561.545 -383.643)",
    fill: "#ff7f8e"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10328",
    "data-name": "Path 10328",
    d: "M586.114,495.684l78.312-45.214V392.5l-78.312,45.214Z",
    transform: "translate(-523.718 -356.479)",
    fill: "#7076a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10329",
    "data-name": "Path 10329",
    d: "M664.426,392.5h-3.451l-74.861,43.221v1.991Z",
    transform: "translate(-523.718 -356.479)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10330",
    "data-name": "Path 10330",
    d: "M565.834,440.7v-1.991l-58.947-34.033h-3.449Z",
    transform: "translate(-503.438 -359.466)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10331",
    "data-name": "Path 10331",
    d: "M534.018,437.848a2.533,2.533,0,0,0-.329,1.352v5.545a5.3,5.3,0,0,0,2.213,4.229l14.044,8.108a1.871,1.871,0,0,0,.734.254,1.282,1.282,0,0,1-1.884.321l-14.044-8.109a5.3,5.3,0,0,1-2.214-4.228v-5.545C532.539,438.49,533.157,437.756,534.018,437.848Z",
    transform: "translate(-510.576 -367.601)",
    fill: "#cdd4ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10332",
    "data-name": "Path 10332",
    d: "M503.438,404.678v57.968l62.4,36.024V440.7ZM525.4,431.641c0-1.63.991-2.379,2.214-1.673l14.044,8.109a5.3,5.3,0,0,1,2.213,4.228v5.545c0,1.63-.991,2.379-2.213,1.673l-14.044-8.109a5.3,5.3,0,0,1-2.214-4.228Z",
    transform: "translate(-503.438 -359.466)",
    fill: "#636094"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5634",
    "data-name": "Group 5634",
    transform: "translate(18.291 83.943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10333",
    "data-name": "Path 10333",
    d: "M527.673,473.04l24.555,14.177V470.174L527.673,456Z",
    transform: "translate(-527.673 -455.997)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5632",
    "data-name": "Group 5632",
    transform: "translate(3.068 5.601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10334",
    "data-name": "Path 10334",
    d: "M531.738,464.083l18.42,10.635v-.664l-18.42-10.635Z",
    transform: "translate(-531.738 -463.419)",
    fill: "#8187b2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5633",
    "data-name": "Group 5633",
    transform: "translate(3.068 10.296)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10335",
    "data-name": "Path 10335",
    d: "M531.738,470.3l18.42,10.635v-.664l-18.42-10.635Z",
    transform: "translate(-531.738 -469.639)",
    fill: "#8187b2"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10336",
    "data-name": "Path 10336",
    d: "M622.71,457.5V477l31.016-17.907v-19.5Z",
    transform: "translate(-532.695 -368.03)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10337",
    "data-name": "Path 10337",
    d: "M630.479,471.5v.918l19.291-11.138v-.918Z",
    transform: "translate(-534.6 -373.126)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10338",
    "data-name": "Path 10338",
    d: "M630.479,464.35v.918l19.291-11.138v-.918Z",
    transform: "translate(-534.6 -371.371)",
    fill: "#8187b2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10339",
    "data-name": "Path 10339",
    d: "M501.432,383.841l79.819-46.084,63.905,36.9-79.819,46.083Z",
    transform: "translate(-501.432 -337.757)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10340",
    "data-name": "Path 10340",
    d: "M501.432,398.819v7.547l63.905,36.9v-7.547Z",
    transform: "translate(-501.432 -352.735)",
    fill: "#b7bbd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10341",
    "data-name": "Path 10341",
    d: "M586.108,432.729v7.547l79.819-46.083v-7.547Z",
    transform: "translate(-522.203 -349.749)",
    fill: "#cdd4ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5639",
    "data-name": "Group 5639",
    transform: "translate(316.568 214.132)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10342",
    "data-name": "Path 10342",
    d: "M520.006,368.922l53.926-31.134L655.019,384.6l-53.926,31.135Z",
    transform: "translate(-520.005 -329.632)",
    fill: "#8187b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10343",
    "data-name": "Path 10343",
    d: "M672.547,381.953l-81.087-46.816v-8.156L672.547,373.8Z",
    transform: "translate(-537.533 -326.981)",
    fill: "#b7bbd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10344",
    "data-name": "Path 10344",
    d: "M672.547,382.163l-81.087-46.816v-7.508l81.087,46.816Z",
    transform: "translate(-537.533 -327.192)",
    fill: "#7076a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10345",
    "data-name": "Path 10345",
    d: "M573.932,335.137l-53.926,31.134v-8.156l53.926-31.134Z",
    transform: "translate(-520.005 -326.981)",
    fill: "#b7bbd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10346",
    "data-name": "Path 10346",
    d: "M574.172,335.347,520.985,366.9v-8.156l53.187-30.909Z",
    transform: "translate(-520.246 -327.192)",
    fill: "#7076a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10347",
    "data-name": "Path 10347",
    d: "M601.963,422.717,520.876,375.9v-8.156l81.087,46.816Z",
    transform: "translate(-520.219 -336.981)",
    fill: "#b7bbd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10348",
    "data-name": "Path 10348",
    d: "M626.591,419.658l14.106-8.144a1.31,1.31,0,0,1,1.66.066l1.657,1.913,19.3-11.156,1.771-4.09a3.425,3.425,0,0,1,1.322-1.58l14.106-8.144.647.37-.647.7v7.09l-53.927,31.134Z",
    transform: "translate(-546.151 -342.078)",
    fill: "#b7bbd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10349",
    "data-name": "Path 10349",
    d: "M627.448,420.148,641.554,412a1,1,0,0,1,1.322.054l1.771,2.045,19.529-11.275,1.771-4.09a3.426,3.426,0,0,1,1.321-1.579l14.106-8.144v8.155L627.449,428.3Z",
    transform: "translate(-546.361 -342.198)",
    fill: "#7076a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10350",
    "data-name": "Path 10350",
    d: "M601.093,423.207l-81.087-46.816v-8.156l81.087,46.816Z",
    transform: "translate(-520.005 -337.101)",
    fill: "#636094"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5637",
    "data-name": "Group 5637",
    transform: "translate(11.432 11.054)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10351",
    "data-name": "Path 10351",
    d: "M658.555,385.443l-41.98,24.237-7.339-1.189,41.98-24.237Z",
    transform: "translate(-553.325 -352.084)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10352",
    "data-name": "Path 10352",
    d: "M577.133,341.628l-41.98,24.237,55.911,32.17,41.98-24.237Z",
    transform: "translate(-535.153 -341.628)",
    fill: "#e3e7ec"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5638",
    "data-name": "Group 5638",
    transform: "translate(6.962 0.19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10353",
    "data-name": "Path 10353",
    d: "M631.115,369.277l-41.98,24.237-18.967-16.24,41.98-24.237Z",
    transform: "translate(-539.272 -333.563)",
    fill: "#f7f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10354",
    "data-name": "Path 10354",
    d: "M604.21,403.972l41.98-24.237-8.911-5.18L595.3,398.793Z",
    transform: "translate(-545.437 -338.842)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10355",
    "data-name": "Path 10355",
    d: "M606.339,351.4l-41.98,24.237-17.871-5.049,41.98-24.237Z",
    transform: "translate(-533.464 -331.922)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10356",
    "data-name": "Path 10356",
    d: "M571.211,327.234l-41.98,24.237L542.254,365.9l41.98-24.237Z",
    transform: "translate(-529.23 -327.234)",
    fill: "#f7f7f9"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNofiles);
export default __webpack_public_path__ + "static/media/nofiles.0df32eda84154dfdcd43329e7a757504.svg";
export { ForwardRef as ReactComponent };